webpackJsonp([1],{

/***/ "0184":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Flw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-material/dist/vue-material.js
var vue_material = __webpack_require__("Lgyv");
var vue_material_default = /*#__PURE__*/__webpack_require__.n(vue_material);

// EXTERNAL MODULE: ./node_modules/vue-snotify/vue-snotify.esm.js
var vue_snotify_esm = __webpack_require__("HgYs");

// EXTERNAL MODULE: ./node_modules/v-tooltip/dist/v-tooltip.esm.js
var v_tooltip_esm = __webpack_require__("VN6J");

// EXTERNAL MODULE: ./node_modules/vuejs-dialog/dist/vuejs-dialog.min.js
var vuejs_dialog_min = __webpack_require__("7VfX");
var vuejs_dialog_min_default = /*#__PURE__*/__webpack_require__.n(vuejs_dialog_min);

// EXTERNAL MODULE: ./node_modules/vue-moment/vue-moment.js
var vue_moment = __webpack_require__("mjDs");
var vue_moment_default = /*#__PURE__*/__webpack_require__.n(vue_moment);

// EXTERNAL MODULE: ./node_modules/vue-shortkey/dist/index.js
var dist = __webpack_require__("m0IH");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// CONCATENATED MODULE: ./src/.env.js
// export const API_PORT = '4000'
var API_URL = 'https://whitesidetimes.com/api';
var DOMAIN_TITLE = 'whitesidetimes.com';
// CONCATENATED MODULE: ./src/services/http.init.js


/**
 * request constructor class
 * if auth is required return patched axios instance
 * else return clear axios instance
 */






var http_init_Http = function Http(status) {
  classCallCheck_default()(this, Http);

  this.isAuth = status && status.auth ? status.auth : false;
  this.instance = axios_default.a.create({
    baseURL: API_URL
  });

  if (this.isAuth) {
    this.instance.interceptors.request.use(function (request) {
      request.headers['token'] = localStorage.getItem('accessToken');
      // if access token expired and refreshToken is exist >> go to API and get new access token
      if (isAccessTokenExpired() && getRefreshToken()) {
        return refreshTokens().then(function (response) {
          request.headers['token'] = response.data.accessToken;
          return request;
        }).catch(function (error) {
          return console.log(error);
        });
      } else {
        return request;
      }
    }, function (error) {
      return promise_default.a.reject(error);
    });

    return this.instance;
  }
  return this.instance;
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__("309y");
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);

// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__("NGEn");
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);

// CONCATENATED MODULE: ./src/services/util.js







/**
 * Return message for HTTP status code
 * @param {number} status - HTTP status code
 * @returns {string} Message of network operation
 */
function _getStatusMessage(status) {
  var message = '';
  switch (status) {
    case 200:
      message = 'All done. Request successfully executed';
      break;
    case 201:
      message = 'Data successfully created';
      break;
    case 400:
      message = 'Validation error';
      break;
    case 401:
      message = 'Need auth';
      break;
    case 404:
      message = 'Not found';
      break;
    case 503:
      message = 'Service Unavailable';
      break;
    case 1000:
      message = 'Client application can\'t get response from API';
      break;
    default:
      message = 'Something wrong. Default error message';
      break;
  }
  return message;
}

function _getResponseErrorMessage(error) {
  if (error.response && error.response.data) return error.response.data.description;
  if (error.response && error.response.statusText) return error.response.statusText;
  if (error.message) return error.message;
  return '_getResponseErrorMessage can\'t handle error';
}

/**
 * Create instant, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
var util_ResponseWrapper = function ResponseWrapper(response) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = arguments[2];

  classCallCheck_default()(this, ResponseWrapper);

  this.data = data;
  this.success = response.data.success;
  this.status = response.status;
  this.statusMessage = _getStatusMessage(this.status);
  this.message = message || null;
};

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
var util_ErrorWrapper = function (_Error) {
  inherits_default()(ErrorWrapper, _Error);

  function ErrorWrapper(error, message) {
    classCallCheck_default()(this, ErrorWrapper);

    var _this = possibleConstructorReturn_default()(this, (ErrorWrapper.__proto__ || get_prototype_of_default()(ErrorWrapper)).call(this));

    _this.name = 'ErrorWrapper';
    _this.stack = new Error().stack;
    _this.success = error.response ? error.response.data.success : false;
    _this.status = error.response ? error.response.status : false;
    _this.statusMessage = _getStatusMessage(_this.status);
    _this.message = message || _getResponseErrorMessage(error);
    return _this;
  }

  return ErrorWrapper;
}(Error);

/**
 * Uses to clear request data before send it
 * Client shouldn't change entity id
 * @param data
 * @return {{}}
 */
function clearData(data) {
  var result = {};
  forEach_default()(data, function (item, propName) {
    if (isArray_default()(item) && item.length) {
      result[propName] = item;
    }
    if (!isArray_default()(item) && item && propName !== 'id') {
      result[propName] = item;
    }
  });
  return result;
}
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/index.js



vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    userData: {
      id: '',
      role: '',
      name: '',
      email: ''
    },
    accessTokenExpDate: '',
    currentAlbum: [],

    // DOM constants
    windowWidth: 0,
    mobileMaxWidth: 320,
    tabletMaxWidth: 1024
  },

  actions: {},

  mutations: {
    SET_USER: function SET_USER(state, accessTokenData) {
      state.userData = accessTokenData;
    },
    SET_ATOKEN_EXP_DATE: function SET_ATOKEN_EXP_DATE(state, expDate) {
      state.accessTokenExpDate = expDate;
    },
    SET_CURRENT_ALBUM: function SET_CURRENT_ALBUM(state, list) {
      state.currentAlbum = list;
    },
    SET_WINDOW_WIDTH: function SET_WINDOW_WIDTH(state, value) {
      state.windowWidth = value;
    }
  },

  getters: {
    userData: function userData(state) {
      return state.userData;
    },

    isMobile: function isMobile(state) {
      return state.windowWidth <= state.mobileMaxWidth;
    },
    isTablet: function isTablet(state) {
      return state.windowWidth <= state.tabletMaxWidth;
    }
  },

  modules: {}
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/Profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Profile = ({
  name: 'ProfilePage'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aba62920","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/Profile.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile page"},[_c('div',{staticClass:"sidebar col-2"},[_c('router-link',{attrs:{"tag":"md-button","to":{ name: 'profile-albums' }}},[_vm._v("\n      albums\n    ")]),_vm._v(" "),_c('router-link',{attrs:{"tag":"md-button","to":{ name: 'profile-tags' }}},[_vm._v("\n      tags\n    ")]),_vm._v(" "),_c('router-link',{attrs:{"tag":"md-button","to":{ name: 'profile-settings' }}},[_vm._v("\n      settings\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"main col-10"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var profile_Profile = (esExports);
// CONCATENATED MODULE: ./src/pages/profile/Profile.vue
function injectStyle (ssrContext) {
  __webpack_require__("w8db")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aba62920"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Profile,
  profile_Profile,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pages_profile_Profile = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/services/albums.service.js





var ENTITY = 'albums';

function create(data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post('' + ENTITY, data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function update(id, data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).patch(ENTITY + '/' + id, data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function getById(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).get(ENTITY + '/' + id).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function remove(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).delete(ENTITY + '/' + id).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function getLast() {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http().get(ENTITY + '/last').then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function getListPublic() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var params = extends_default()({}, parameters);
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http().get('' + ENTITY, { params: params }).then(function (response) {
      var data = {
        content: response.data.data.results,
        total: response.data.data.total
      };
      resolve(new util_ResponseWrapper(response, data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function getList() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var params = extends_default()({}, parameters);
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).get('' + ENTITY, { params: params }).then(function (response) {
      var data = {
        content: response.data.data.results,
        total: response.data.data.total
      };
      resolve(new util_ResponseWrapper(response, data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

// PROGRESS BAR EXAMPLE
// export function uploadCoverIndexImage (id, data) {
//   const config = {
//     onUploadProgress (progressEvent) {
//       let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
//       console.log('onUploadProgress', percentCompleted)
//     }
//   }
//   return new Promise((resolve, reject) => {
//     new Http({auth: true}).post(`${ENTITY}/${id}/cover/index`, data, config)
//       .then(response => resolve(new ResponseWrapper(response, response.data.data)))
//       .catch(error => reject(new ErrorWrapper(error)))
//   })
// }

function uploadCoverIndexImage(id, data) {
  var config = {
    onUploadProgress: function onUploadProgress(progressEvent) {
      var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      console.log('onUploadProgress', percentCompleted);
    }
  };
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post(ENTITY + '/' + id + '/cover/index', data, config).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function removeCoverIndexImage(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).delete(ENTITY + '/' + id + '/cover/index').then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function uploadCoverThumbnailImage(id, data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post(ENTITY + '/' + id + '/cover/thumbnail', data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function removeCoverThumbnailImage(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).delete(ENTITY + '/' + id + '/cover/thumbnail').then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function uploadPhotoToAlbum(id, data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post(ENTITY + '/' + id + '/upload', data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function attachTag(albumId, tagId) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post(ENTITY + '/' + albumId + '/attach-tag/' + tagId).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function detachTag(albumId, tagId) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post(ENTITY + '/' + albumId + '/detach-tag/' + tagId).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}
// CONCATENATED MODULE: ./src/mixins/prepareFetchParamsMixin.js


/* harmony default export */ var mixins_prepareFetchParamsMixin = ({
  methods: {
    prepareFetchParamsMixin: function prepareFetchParamsMixin(data) {
      var obj = {};
      forEach_default()(data, function (item, prop) {
        if (Array.isArray(item) && item.length) {
          obj[prop] = item;
        }
        if (typeof item === 'boolean' && item) {
          obj[prop] = item;
        }
        if (typeof item === 'string' && item.length) {
          obj[prop] = item;
        }
        if (typeof item === 'number' && item) {
          obj[prop] = item;
        }
      });

      return obj;
    }
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var array_from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(array_from);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pagination.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Component compatibility developed with pagination that starts from 0 page
 */
/* harmony default export */ var Pagination = ({
  name: 'Pagination',
  props: {
    page: {
      /**
       * current page number
       */
      type: Number,
      default: 0,
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    },
    limit: {
      type: Number,
      default: 0,
      required: true
    },
    /**
     * max count of pages button
     */
    maxPages: {
      type: Number,
      default: 5
    }
  },

  data: function data() {
    return {
      current: this.page
    };
  },


  methods: {
    goToPage: function goToPage(pageNumber) {
      if (pageNumber < 0 || pageNumber > this.pagesCount) return;
      this.current = pageNumber;
      this.$emit('update:page', this.current);
      document.querySelector('.header.wrapper').scrollIntoView({ behavior: 'smooth' });
    }
  },

  computed: {
    pagesCount: function pagesCount() {
      // divide total to limit
      // if haven't remainder
      if (this.total % this.limit === 0) return this.total / this.limit;
      // if have remainder
      return parseInt(this.total / this.limit) + 1;
    },
    pagesArray: function pagesArray() {
      return from_default()(new Array(this.pagesCount)).map(function (item, key) {
        return item = key;
      });
    },
    visiblePagesArray: function visiblePagesArray() {
      return this.pagesArray.slice(this.visiblePagesArrayFirstIndex, this.visiblePagesArrayLastIndex);
    },
    visiblePagesArrayFirstIndex: function visiblePagesArrayFirstIndex() {
      var pagesArrayLengthMinusMaxPages = this.pagesArray.length - this.maxPages;
      if (this.current >= pagesArrayLengthMinusMaxPages && pagesArrayLengthMinusMaxPages > 0) {
        return pagesArrayLengthMinusMaxPages;
      }
      return this.current;
    },
    visiblePagesArrayLastIndex: function visiblePagesArrayLastIndex() {
      var pagesArrayLengthMinusMaxPages = this.pagesArray.length - this.maxPages;
      if (this.current >= pagesArrayLengthMinusMaxPages) {
        return this.pagesArray.length;
      }
      return this.current + this.maxPages;
    },
    isDisabledNextBtn: function isDisabledNextBtn() {
      return this.current === this.pagesCount - 1;
    },
    isDisabledPrevBtn: function isDisabledPrevBtn() {
      return !this.current;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e14a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
var Pagination_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination component"},[_c('li',[_c('button',{staticClass:"nav-btn first",attrs:{"disabled":_vm.isDisabledPrevBtn},on:{"click":function($event){_vm.goToPage(0)}}},[_vm._v("first")])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"nav-btn previous",attrs:{"disabled":_vm.isDisabledPrevBtn},on:{"click":function($event){_vm.goToPage(_vm.current - 1)}}},[_vm._v("prev")])]),_vm._v(" "),_vm._l((_vm.visiblePagesArray),function(page){return _c('li',[_c('button',{staticClass:"item",class:{ 'active': _vm.current === page },attrs:{"disabled":_vm.current === page},on:{"click":function($event){_vm.goToPage(page)}}},[_vm._v("\n      "+_vm._s(page + 1)+"\n    ")])])}),_vm._v(" "),_c('li',[_c('button',{staticClass:"nav-btn next",attrs:{"disabled":_vm.isDisabledNextBtn},on:{"click":function($event){_vm.goToPage(_vm.current + 1)}}},[_vm._v("next")])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"nav-btn last",attrs:{"disabled":_vm.isDisabledNextBtn},on:{"click":function($event){_vm.goToPage(_vm.pagesCount - 1)}}},[_vm._v("last")])]),_vm._v(" "),_c('li',{staticClass:"info pages-counter"},[_vm._v(_vm._s(_vm.current + 1)+"/"+_vm._s(_vm.pagesCount))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',{staticClass:"info total-counter"},[_vm._v("Total: "+_vm._s(_vm.total))])],2)}
var Pagination_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',{staticClass:"separator"},[_vm._v("|")])])}]
var Pagination_esExports = { render: Pagination_render, staticRenderFns: Pagination_staticRenderFns }
/* harmony default export */ var components_Pagination = (Pagination_esExports);
// CONCATENATED MODULE: ./src/components/Pagination.vue
function Pagination_injectStyle (ssrContext) {
  __webpack_require__("oDzh")
}
var Pagination_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Pagination___vue_template_functional__ = false
/* styles */
var Pagination___vue_styles__ = Pagination_injectStyle
/* scopeId */
var Pagination___vue_scopeId__ = "data-v-561e14a8"
/* moduleIdentifier (server only) */
var Pagination___vue_module_identifier__ = null
var Pagination_Component = Pagination_normalizeComponent(
  Pagination,
  components_Pagination,
  Pagination___vue_template_functional__,
  Pagination___vue_styles__,
  Pagination___vue_scopeId__,
  Pagination___vue_module_identifier__
)

/* harmony default export */ var src_components_Pagination = (Pagination_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/AlbumsList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var AlbumsList = ({
  name: 'AlbumsList',
  props: {
    limit: {
      type: Number,
      default: 10 // TODO add API support
    },
    page: {
      type: Number,
      default: 0
    }
  },

  mixins: [mixins_prepareFetchParamsMixin],

  components: {
    Pagination: src_components_Pagination
  },

  watch: {
    'pagination.page': 'fetchData'
  },

  data: function data() {
    return {
      loading: false,
      error: false,
      albums: [],
      pagination: {
        page: this.page,
        limit: this.limit,
        total: 0
      }
    };
  },


  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loading = true;
      getList(this.fetchParams).then(function (response) {
        _this.albums = response.data.content;
        _this.pagination.total = response.data.total;
      }).catch(function (error) {
        _this.error = error;
      }).finally(function () {
        _this.loading = false;
      });
    }
  },

  computed: {
    fetchParams: function fetchParams() {
      var pagination = this.prepareFetchParamsMixin({
        page: this.pagination.page,
        limit: this.pagination.limit
      });

      return extends_default()({}, pagination);
    },
    isEmpty: function isEmpty() {
      return !this.albums.length;
    }
  },

  mounted: function mounted() {
    this.fetchData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb51d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/AlbumsList.vue
var AlbumsList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"albums-list"},[_c('router-link',{attrs:{"tag":"md-button","to":{ name: 'profile-albums-new' }}},[_vm._v("\n    add new album\n  ")]),_vm._v(" "),_c('UiDataBox',{attrs:{"loading":_vm.loading,"isEmpty":_vm.isEmpty,"error":_vm.error}},[_c('table',{staticClass:"table-list"},[_c('thead',{staticClass:"header"},[_c('th',[_vm._v("title")]),_vm._v(" "),_c('th',[_vm._v("created date")]),_vm._v(" "),_c('th',[_vm._v("event date")])]),_vm._v(" "),_vm._l((_vm.albums),function(item){return _c('tr',{key:item.id,staticClass:"item"},[_c('td',{staticClass:"title"},[_c('router-link',{attrs:{"to":{ name:'profile-album-edit', params:{id: item.id} }}},[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.$moment(item.created_at).format(_vm.$FORMAT_DATETIME.DATETIME))+"\n        ")]),_vm._v(" "),_c('td',[(item.event_date)?_c('span',[_vm._v(_vm._s(_vm.$moment(item.event_date).format(_vm.$FORMAT_DATETIME.DATETIME)))]):_vm._e()])])})],2),_vm._v(" "),_c('Pagination',{attrs:{"total":_vm.pagination.total,"limit":_vm.pagination.limit,"page":_vm.pagination.page},on:{"update:page":function($event){_vm.$set(_vm.pagination, "page", $event)}}})],1)],1)}
var AlbumsList_staticRenderFns = []
var AlbumsList_esExports = { render: AlbumsList_render, staticRenderFns: AlbumsList_staticRenderFns }
/* harmony default export */ var profile_AlbumsList = (AlbumsList_esExports);
// CONCATENATED MODULE: ./src/pages/profile/AlbumsList.vue
function AlbumsList_injectStyle (ssrContext) {
  __webpack_require__("nQWg")
}
var AlbumsList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AlbumsList___vue_template_functional__ = false
/* styles */
var AlbumsList___vue_styles__ = AlbumsList_injectStyle
/* scopeId */
var AlbumsList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AlbumsList___vue_module_identifier__ = null
var AlbumsList_Component = AlbumsList_normalizeComponent(
  AlbumsList,
  profile_AlbumsList,
  AlbumsList___vue_template_functional__,
  AlbumsList___vue_styles__,
  AlbumsList___vue_scopeId__,
  AlbumsList___vue_module_identifier__
)

/* harmony default export */ var pages_profile_AlbumsList = (AlbumsList_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-datetime/dist/vue-datetime.js
var vue_datetime = __webpack_require__("QEVx");
var vue_datetime_default = /*#__PURE__*/__webpack_require__.n(vue_datetime);

// EXTERNAL MODULE: ./node_modules/vue-mugen-scroll/dist/vue-mugen-scroll.common.js
var vue_mugen_scroll_common = __webpack_require__("EbDR");
var vue_mugen_scroll_common_default = /*#__PURE__*/__webpack_require__.n(vue_mugen_scroll_common);

// CONCATENATED MODULE: ./src/services/photos.service.js




var photos_service_ENTITY = 'photos';

function photos_service_getById(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).get(photos_service_ENTITY + '/' + id).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function photos_service_remove(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).delete(photos_service_ENTITY + '/' + id).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/mixins/setModelMixin.js

/* harmony default export */ var mixins_setModelMixin = ({
  methods: {
    /**
     * @param currentModel (current model)
     * @param fetchedModel (fetched model data)
     * @return {{}}
     */
    setModelMixin: function setModelMixin(currentModel, fetchedModel) {
      if (!currentModel) throw new Error('requires \'currentModel\' param');
      if (!fetchedModel) throw new Error('requires \'fetchedModel\' param');

      var result = {};
      keys_default()(currentModel).forEach(function (propName) {
        if (propName in fetchedModel) {
          if (![null, undefined].includes(fetchedModel[propName])) {
            result[propName] = fetchedModel[propName];
          }
        }
      });
      return result;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UploadSingle.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UploadSingle = ({
  name: 'UploadSingle',

  props: {
    entityId: {
      type: Number
    },
    entityType: {
      type: String,
      validator: function validator(type) {
        return ['cover_index', 'cover_thumbnail'].includes(type);
      }
    },
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 1 // 1MB
    },
    types: {
      type: Array,
      default: function _default() {
        return ['jpg', 'jpeg'];
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      done: false,
      error: false,
      previewImageData: ''
    };
  },


  methods: {
    makePreviewImage: function makePreviewImage(event) {
      var _this = this;

      var file = event.target.files[0];

      if (this.isValidFile(file)) {
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = function (e) {
          // Note: arrow function used here, so that "this.previewImageData" refers to the previewImageData of Vue component
          // Read image as base64 and set to imageData
          _this.previewImageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(file);
      }
    },
    uploadCoverIndex: function uploadCoverIndex(data) {
      var _this2 = this;

      this.loading = true;
      this.done = false;
      this.error = false;

      uploadCoverIndexImage(this.entityId, data).then(function (response) {
        return _this2.done = true;
      }).catch(function (error) {
        _this2.$snotify.error(error.message, 'Error');
        _this2.error = error.message;
        console.log(error);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    uploadCoverThumbnail: function uploadCoverThumbnail(data) {
      var _this3 = this;

      this.loading = true;
      this.done = false;
      this.error = false;

      uploadCoverThumbnailImage(this.entityId, data).then(function (response) {
        return _this3.done = true;
      }).catch(function (error) {
        _this3.$snotify.error(error.message, 'Error');
        _this3.error = error.message;
        console.log(error);
      }).finally(function () {
        _this3.loading = false;
      });
    },
    upload: function upload() {
      var selectedFile = this.$refs.file.files[0];

      if (this.previewImageData) {
        var data = new FormData();
        data.append(this.entityType, selectedFile);

        if (this.entityType === 'cover_index') {
          this.uploadCoverIndex(data);
        }
        if (this.entityType === 'cover_thumbnail') {
          this.uploadCoverThumbnail(data);
        }
      }
    },
    cancelImage: function cancelImage() {
      this.previewImageData = '';
      this.resetAllStatuses();
    },
    resetAllStatuses: function resetAllStatuses() {
      this.loading = false;
      this.done = false;
      this.error = false;
    },
    isValidFile: function isValidFile(file) {
      if (!file) return;

      var isValid = true;
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.resetAllStatuses();
      this.cancelImage();

      if (file.size > this.maxSize) {
        this.error = 'Max size per file = ' + this.maxSize / 1024 / 1024 + ' MB.';
        return isValid = false;
      }
      if (!this.types.includes(extension)) {
        this.error = 'Not allowed file type.';
        return isValid = false;
      }

      return isValid;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386a9436","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadSingle.vue
var UploadSingle_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-single component"},[_c('div',{staticClass:"top-tools"},[_c('input',{ref:"file",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.makePreviewImage}}),_vm._v(" "),_c('button',{on:{"click":_vm.upload}},[_vm._v("upload")]),_vm._v(" "),_c('button',{on:{"click":_vm.cancelImage}},[_vm._v("cancel")])]),_vm._v(" "),_c('div',{staticClass:"loading-status"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("loading")]):_vm._e(),_vm._v(" "),(_vm.done)?_c('div',{staticClass:"done"},[_vm._v("loaded, all done")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("Error: "+_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),(_vm.previewImageData)?_c('div',{staticClass:"preview"},[_c('img',{attrs:{"src":_vm.previewImageData,"alt":"image"}})]):_vm._e()])}
var UploadSingle_staticRenderFns = []
var UploadSingle_esExports = { render: UploadSingle_render, staticRenderFns: UploadSingle_staticRenderFns }
/* harmony default export */ var components_UploadSingle = (UploadSingle_esExports);
// CONCATENATED MODULE: ./src/components/UploadSingle.vue
function UploadSingle_injectStyle (ssrContext) {
  __webpack_require__("wVqI")
}
var UploadSingle_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UploadSingle___vue_template_functional__ = false
/* styles */
var UploadSingle___vue_styles__ = UploadSingle_injectStyle
/* scopeId */
var UploadSingle___vue_scopeId__ = "data-v-386a9436"
/* moduleIdentifier (server only) */
var UploadSingle___vue_module_identifier__ = null
var UploadSingle_Component = UploadSingle_normalizeComponent(
  UploadSingle,
  components_UploadSingle,
  UploadSingle___vue_template_functional__,
  UploadSingle___vue_styles__,
  UploadSingle___vue_scopeId__,
  UploadSingle___vue_module_identifier__
)

/* harmony default export */ var src_components_UploadSingle = (UploadSingle_Component.exports);

// EXTERNAL MODULE: ./node_modules/bluebird/js/browser/bluebird.js
var bluebird = __webpack_require__("0Qa9");
var bluebird_default = /*#__PURE__*/__webpack_require__.n(bluebird);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UploadMulti.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UploadMulti = ({
  name: 'UploadMulti',

  props: {
    entityId: {
      type: Number
    },
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 2 // 1MB
    },
    maxFiles: {
      type: Number,
      default: 300
    },
    types: {
      type: Array,
      default: function _default() {
        return ['jpg', 'jpeg'];
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      done: false,
      error: false,
      previewImageData: '',
      fileList: [],
      uploadedFilesCounter: 0
    };
  },


  methods: {
    makePreviewImage: function makePreviewImage(event) {
      var _this = this;

      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = function (e) {
          // Note: arrow function used here, so that "this.previewImageData" refers to the previewImageData of Vue component
          // Read image as base64 and set to imageData
          _this.previewImageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
      this.previewImageData = '';
      this.resetAllStatuses();
    },
    onChange: function onChange(event) {
      var _this2 = this;

      var selectedFiles = event.target.files;

      if (this.isValidFiles(selectedFiles)) {
        from_default()(selectedFiles).forEach(function (file) {
          _this2.fileList.push(file);
        });
      }
    },
    upload: function upload() {
      var _this3 = this;

      if (!this.fileList.length) return;

      this.loading = true;
      bluebird_default.a.each(this.fileList, function (file) {
        _this3.uploadedFilesCounter++;
        var formData = new FormData();
        formData.append('photo', file);

        return uploadPhotoToAlbum(_this3.entityId, formData);
      }).then(function (response) {
        _this3.done = true;
        _this3.$emit('uploaded');
      }).catch(function (error) {
        _this3.$snotify.error(error.message, 'Error');
        console.log(error);
      }).finally(function () {
        _this3.loading = false;
        _this3.fileList = [];
      });
    },
    resetSelection: function resetSelection() {
      this.previewImageData = '';
      this.resetAllStatuses();
      this.fileList = [];
    },
    resetAllStatuses: function resetAllStatuses() {
      this.loading = false;
      this.done = false;
      this.error = false;
    },
    removeFile: function removeFile(fileId) {
      this.fileList.splice(fileId, 1);
    },
    isValidFiles: function isValidFiles(files) {
      var _this4 = this;

      var isValid = true;
      this.resetSelection();

      if (files.length > this.maxFiles) {
        this.error = 'Too many files. ' + this.maxFiles + ' files allowed per time.';
        return isValid = false;
      }

      from_default()(files).forEach(function (file) {
        var extension = file.name.substring(file.name.lastIndexOf('.') + 1);

        if (file.size > _this4.maxSize) {
          _this4.error = 'Max size per file = ' + _this4.maxSize / 1024 / 1024 + ' MB.';
          return isValid = false;
        }
        if (!_this4.types.includes(extension)) {
          _this4.error = 'Not allowed file type.';
          return isValid = false;
        }
      });

      return isValid;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c61f52e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadMulti.vue
var UploadMulti_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-multi component"},[_c('div',{staticClass:"top-tools"},[(_vm.fileList.length)?_c('span',[_vm._v(_vm._s(_vm.fileList.length)+" files selected")]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"select-btn",attrs:{"for":"selectFilesInput"}},[_vm._v("select file")]),_vm._v(" "),_c('input',{ref:"filesContainer",attrs:{"id":"selectFilesInput","type":"file","accept":"image/*","multiple":""},on:{"change":_vm.onChange}}),_vm._v(" "),_c('button',{attrs:{"disabled":!_vm.fileList.length},on:{"click":_vm.upload}},[_vm._v("upload")]),_vm._v(" "),_c('button',{on:{"click":_vm.resetSelection}},[_vm._v("cancel")])]),_vm._v(" "),_c('div',{staticClass:"loading-status"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("loading ("+_vm._s(_vm.uploadedFilesCounter)+" of "+_vm._s(_vm.fileList.length)+")")]):_vm._e(),_vm._v(" "),(_vm.done)?_c('div',{staticClass:"done"},[_vm._v("loaded, all done")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("Error: "+_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"selected-files"},_vm._l((_vm.fileList),function(item,index){return _c('div',{key:index,staticClass:"file"},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(parseInt(item.size / 1024))+"kb")]),_vm._v(" "),_c('button',{staticClass:"remove-btn",on:{"click":function($event){_vm.removeFile(index)}}},[_vm._v("remove")])])}))])}
var UploadMulti_staticRenderFns = []
var UploadMulti_esExports = { render: UploadMulti_render, staticRenderFns: UploadMulti_staticRenderFns }
/* harmony default export */ var components_UploadMulti = (UploadMulti_esExports);
// CONCATENATED MODULE: ./src/components/UploadMulti.vue
function UploadMulti_injectStyle (ssrContext) {
  __webpack_require__("gYkr")
}
var UploadMulti_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UploadMulti___vue_template_functional__ = false
/* styles */
var UploadMulti___vue_styles__ = UploadMulti_injectStyle
/* scopeId */
var UploadMulti___vue_scopeId__ = "data-v-7c61f52e"
/* moduleIdentifier (server only) */
var UploadMulti___vue_module_identifier__ = null
var UploadMulti_Component = UploadMulti_normalizeComponent(
  UploadMulti,
  components_UploadMulti,
  UploadMulti___vue_template_functional__,
  UploadMulti___vue_styles__,
  UploadMulti___vue_scopeId__,
  UploadMulti___vue_module_identifier__
)

/* harmony default export */ var src_components_UploadMulti = (UploadMulti_Component.exports);

// CONCATENATED MODULE: ./src/services/tags.service.js





var tags_service_ENTITY = 'tags';

function tags_service_getList() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var params = extends_default()({}, parameters);
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http().get('' + tags_service_ENTITY, { params: params }).then(function (response) {
      var data = {
        content: response.data.data
        // total: response.data.data.total
      };
      resolve(new util_ResponseWrapper(response, data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function getAlbumsByTagId(tag_id) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var params = extends_default()({}, parameters);
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http().get(tags_service_ENTITY + '/' + tag_id + '/albums', { params: params }).then(function (response) {
      var data = {
        content: response.data.data.results,
        total: response.data.data.total
      };
      resolve(new util_ResponseWrapper(response, data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function tags_service_getById(tag_id) {
  return new promise_default.a(function (resolve, reject) {
    return new http_init_Http().get(tags_service_ENTITY + '/' + tag_id).then(function (response) {
      // console.log('response', response)
      resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      var message = error.response.data ? error.response.data.error : error.response.statusText;
      reject(new util_ErrorWrapper(error, message));
    });
  });
}

function getByName(tag_name) {
  return new promise_default.a(function (resolve, reject) {
    return new http_init_Http().get(tags_service_ENTITY + '/' + tag_name).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      var message = error.response.data ? error.response.data.error : error.response.statusText;
      reject(new util_ErrorWrapper(error, message));
    });
  });
}

function tags_service_create(data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post('' + tags_service_ENTITY, data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function tags_service_update(id, data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).patch(tags_service_ENTITY + '/' + id, data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function tags_service_remove(id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).delete(tags_service_ENTITY + '/' + id).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function find() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var params = extends_default()({}, parameters);
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http().get(tags_service_ENTITY + '/find', { params: params }).then(function (response) {
      var data = {
        content: response.data.data
        // total: response.data.data.total
      };
      resolve(new util_ResponseWrapper(response, data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}
// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TagsSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var TagsSelect = ({
  name: 'TagsSelect',
  components: { Multiselect: vue_multiselect_min_default.a },
  props: {
    selectedIds: {
      type: Array,
      'default': function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      selected: [],
      options: []
    };
  },

  methods: {
    processOptions: function processOptions(data) {
      return data.map(function (item) {
        return extends_default()({}, item, { label: item.name });
      });
    },
    fetch: function fetch() {
      var _this = this;

      this.loading = true;
      tags_service_getList().then(function (response) {
        _this.options = _this.processOptions(response.data.content);
      }).catch(function (error) {
        console.log('error', error);
      }).finally(function () {
        _this.loading = false;
      });
    },
    onSelect: function onSelect(selectedOption, id) {
      if (!this.selected.find(function (item) {
        return item.id === selectedOption.id;
      })) {
        this.selected.push(selectedOption);
        this.$emit('select', selectedOption);
      }
    },
    onRemove: function onRemove(removedOption) {
      this.selected = this.selected.filter(function (item) {
        return item.id !== removedOption.id;
      });
      this.$emit('remove', removedOption, this.selected);
    }
  },
  watch: {
    selectedIds: function selectedIds(newValue, oldValue) {
      this.selected = this.processOptions(newValue);
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35266438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsSelect.vue
var TagsSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',{staticClass:"tags-select component",attrs:{"select-label":"","selected-label":"","deselect-label":"","hideSelected":"","close-on-select":false,"multiple":true,"value":_vm.selected,"options":_vm.options,"loading":_vm.loading,"allow-empty":true,"label":'label',"placeholder":"Add tag","track-by":"id"},on:{"select":_vm.onSelect,"remove":_vm.onRemove},scopedSlots:_vm._u([{key:"tag",fn:function(props){return [_c('span',{staticClass:"ws-tag"},[_c('span',[_vm._v(_vm._s(props.option.label))]),_vm._v(" "),_c('span',{staticClass:"remove",on:{"click":function($event){props.remove(props.option)}}})])]}},{key:"option",fn:function(props){return [_c('div',{staticClass:"option-item"},[_vm._v(_vm._s(props.option.label))])]}}])},[_c('template',{slot:"noResult"},[_c('span',[_vm._v("Nothing here")])])],2)}
var TagsSelect_staticRenderFns = []
var TagsSelect_esExports = { render: TagsSelect_render, staticRenderFns: TagsSelect_staticRenderFns }
/* harmony default export */ var components_TagsSelect = (TagsSelect_esExports);
// CONCATENATED MODULE: ./src/components/TagsSelect.vue
function TagsSelect_injectStyle (ssrContext) {
  __webpack_require__("dxAA")
  __webpack_require__("YrBY")
}
var TagsSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagsSelect___vue_template_functional__ = false
/* styles */
var TagsSelect___vue_styles__ = TagsSelect_injectStyle
/* scopeId */
var TagsSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TagsSelect___vue_module_identifier__ = null
var TagsSelect_Component = TagsSelect_normalizeComponent(
  TagsSelect,
  components_TagsSelect,
  TagsSelect___vue_template_functional__,
  TagsSelect___vue_styles__,
  TagsSelect___vue_scopeId__,
  TagsSelect___vue_module_identifier__
)

/* harmony default export */ var src_components_TagsSelect = (TagsSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/AlbumCreateEdit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * альбом создается в несколько этапов
 * 1) Создается сущьность альбом
 * 1.1) Открывается след шаг
 * 2) Загружаются заглавные изображения, фото и добавдяются теги
 * 3) Публикуется альбом
 */











/* harmony default export */ var AlbumCreateEdit = ({
  name: 'AlbumCreateEdit',
  mixins: [mixins_setModelMixin],
  components: {
    UploadSingle: src_components_UploadSingle,
    UploadMulti: src_components_UploadMulti,
    TagsSelect: src_components_TagsSelect,
    Datetime: vue_datetime["Datetime"],
    MugenScroll: vue_mugen_scroll_common_default.a
  },

  data: function data() {
    return {
      loading: false,
      error: false,
      photoArrayLimiter: 20,

      item: {
        id: null,
        user_id: '',
        title: '',
        description: '',
        private: true,
        event_date: '',
        created_at: '',
        _cover_thumbnail: '',
        _cover_index: '',
        tags: [],
        photos: []
      }
    };
  },


  methods: {
    log: function log() {
      console.log(this.item);
    },
    createUpdateItem: function createUpdateItem() {
      this.item.id ? this.updateItem() : this.createItem();
    },
    createItem: function createItem() {
      var _this = this;

      var data = {
        user_id: this.$currentUser.id,
        title: this.item.title,
        description: this.item.description,
        private: this.item.private,
        event_date: this.item.event_date
      };

      this.loading = true;
      create(data).then(function (response) {
        _this.item = _this.setModelMixin(_this.item, response.data);
        _this.item.tags = [];
        _this.$router.push({ name: 'profile-album-edit', params: { id: _this.item.id } });
        _this.$snotify.success('Album is created', 'All done!');
      }).catch(function (error) {
        _this.$snotify.error(error.message, 'Error');
        console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      var data = {
        user_id: this.$currentUser.id,
        title: this.item.title,
        description: this.item.description,
        private: this.item.private,
        event_date: this.item.event_date
      };

      this.loading = true;
      update(this.item.id, data).then(function (response) {
        _this2.item = _this2.setModelMixin(_this2.item, response.data);
        _this2.$snotify.success('Album is updated', 'All done!');
      }).catch(function (error) {
        _this2.$snotify.error(error.message, 'Error');
        console.log(error);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    fetchItem: function fetchItem() {
      var _this3 = this;

      this.loading = true;
      getById(this.$route.params.id).then(function (response) {
        _this3.item = _this3.setModelMixin(_this3.item, response.data);
      }).catch(function (error) {
        return console.log(error);
      }).finally(function () {
        _this3.loading = false;
      });
    },
    removeItem: function removeItem() {
      var _this4 = this;

      this.$dialog.confirm('Remove album #' + this.item.id + ' ' + this.item.title + ' ?').then(function () {
        return remove(_this4.item.id);
      }).then(function (response) {
        _this4.$snotify.success('Album is deleted', 'All done!');
        _this4.$router.push({ name: 'profile-albums' });
      }).catch(function (error) {
        if (error && error.message) {
          _this4.$snotify.error(error.message, 'Error');
        }
        console.log(error);
      });
    },
    removeCoverIndex: function removeCoverIndex() {
      var _this5 = this;

      removeCoverIndexImage(this.item.id).then(function (response) {
        _this5.$snotify.success('Cover index deleted', 'All done!');
        _this5._cover_index = '';
      }).catch(function (error) {
        _this5.$snotify.error(error.message, 'Error');
        console.log(error);
      });
    },
    removeCoverThumbnail: function removeCoverThumbnail() {
      var _this6 = this;

      removeCoverThumbnailImage(this.item.id).then(function (response) {
        _this6.$snotify.success('Cover thumbnail deleted', 'All done!');
        _this6._cover_thumbnail = '';
      }).catch(function (error) {
        _this6.$snotify.error(error.message, 'Error');
        console.log(error);
      });
    },
    onTagSelect: function onTagSelect(selectedTag) {
      var _this7 = this;

      attachTag(this.item.id, selectedTag.id).then(function (response) {
        _this7.item.tags.push(selectedTag);
        _this7.$snotify.success('Attached', 'Tag: ' + selectedTag.label);
      }).catch(function (error) {
        _this7.$snotify.error(error.message, 'Error');
        console.log(error);
      });
    },
    onTagRemove: function onTagRemove(selectedTag) {
      var _this8 = this;

      detachTag(this.item.id, selectedTag.id).then(function (response) {
        _this8.item.tags = _this8.item.tags.filter(function (item) {
          return item.id !== selectedTag.id;
        });
        _this8.$snotify.success('Detached', 'Tag: ' + selectedTag.label);
      }).catch(function (error) {
        _this8.$snotify.error(error.message, 'Error');
        console.log(error);
      });
    },
    removePhoto: function removePhoto(photoId) {
      var _this9 = this;

      this.$dialog.confirm('Remove photo #' + photoId + ' ?').then(function () {
        return photos_service_remove(photoId);
      }).then(function () {
        _this9.$snotify.success('Removed', 'Photo: ' + photoId);
        _this9.item.photos = _this9.item.photos.filter(function (item) {
          return item.id !== photoId;
        });
      }).catch(function (error) {
        if (error && error.message) {
          _this9.$snotify.error(error.message, 'Error');
        }
        console.log(error);
      });
    },
    loadMorePhotosHandler: function loadMorePhotosHandler() {
      if (this.photoArrayLimiter > this.item.photos.length) return;
      this.photoArrayLimiter += 8;
    }
  },

  computed: {
    isNew: function isNew() {
      return !this.item.id;
    },
    createUpdateButtonTitle: function createUpdateButtonTitle() {
      return this.item.id ? 'Update' : 'Create';
    },
    isChangeSwitchPrivateDisabled: function isChangeSwitchPrivateDisabled() {
      return this.isNew || !this.item._cover_thumbnail;
    },

    eventDate: {
      get: function get() {
        return this.item.event_date ? this.item.event_date : '';
      },
      set: function set(date) {
        if (this.item.event_date) {
          this.item.event_date = date;
        } else {
          this.$set(this.item, 'event_date', date);
        }
      }
    },
    isDisabledCreateUpdateButton: function isDisabledCreateUpdateButton() {
      return this.loading || !this.item.title || !this.item.event_date;
    },
    getPhotosList: function getPhotosList() {
      if (!this.item.photos) return;
      return this.item.photos.slice(0, this.photoArrayLimiter);
    }
  },

  mounted: function mounted() {
    if (this.$route.params.id) {
      this.fetchItem();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a16a0a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/AlbumCreateEdit.vue
var AlbumCreateEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"album-create-edit"},[_c('UiDataBox',{attrs:{"loading":_vm.loading}},[_c('md-tabs',{attrs:{"md-fixed":""}},[_c('md-tab',{attrs:{"id":"album","md-label":_vm.isNew ? 'New album' : 'Edit album'}},[_c('div',{staticClass:"form-control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.title),expression:"item.title"}],attrs:{"type":"text","placeholder":"Title"},domProps:{"value":(_vm.item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.description),expression:"item.description"}],attrs:{"placeholder":"Description"},domProps:{"value":(_vm.item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',[_vm._v("Event date:")]),_vm._v(" "),_c('Datetime',{attrs:{"placeholder":"Choose event date"},model:{value:(_vm.eventDate),callback:function ($$v) {_vm.eventDate=$$v},expression:"eventDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-control button"},[_c('md-switch',{attrs:{"disabled":_vm.isChangeSwitchPrivateDisabled},model:{value:(_vm.item.private),callback:function ($$v) {_vm.$set(_vm.item, "private", $$v)},expression:"item.private"}},[_vm._v("\n            "+_vm._s(_vm.item.private ? 'Private' : 'Public')+"\n            "),(!_vm.item._cover_thumbnail)?_c('span',[_vm._v("(Upload cover thumbnail to unlock switcher)")]):_vm._e()]),_vm._v(" "),_c('div',[_c('md-button',{attrs:{"disabled":_vm.isDisabledCreateUpdateButton},on:{"click":_vm.createUpdateItem}},[_vm._v(_vm._s(_vm.createUpdateButtonTitle))]),_vm._v(" "),(!_vm.isNew)?_c('md-button',{on:{"click":_vm.removeItem}},[_vm._v("Remove album")]):_vm._e()],1)],1)]),_vm._v(" "),_c('md-tab',{attrs:{"id":"content","md-label":"Content","md-disabled":_vm.isNew}},[_c('div',{staticClass:"form-control"},[_c('TagsSelect',{attrs:{"selectedIds":_vm.item.tags},on:{"select":_vm.onTagSelect,"remove":_vm.onTagRemove}})],1),_vm._v(" "),_c('div',{staticClass:"image"},[_c('div',{staticClass:"current-image form-control"},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("Cover index")]),_vm._v(" "),_c('button',{on:{"click":_vm.removeCoverIndex}},[_vm._v("remove")])]),_vm._v(" "),_c('img',{attrs:{"src":_vm.item._cover_index,"alt":"current index cover image"}})]),_vm._v(" "),_c('div',{staticClass:"upload-new-image form-control"},[_c('UploadSingle',{attrs:{"entityId":_vm.item.id,"entityType":'cover_index'}})],1)]),_vm._v(" "),_c('div',{staticClass:"image"},[_c('div',{staticClass:"current-image form-control"},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("Cover thumbnail")]),_vm._v(" "),_c('button',{on:{"click":_vm.removeCoverThumbnail}},[_vm._v("remove")])]),_vm._v(" "),_c('img',{attrs:{"src":_vm.item._cover_thumbnail,"alt":"current index cover image"}})]),_vm._v(" "),_c('div',{staticClass:"upload-new-image form-control"},[_c('UploadSingle',{attrs:{"entityId":_vm.item.id,"entityType":'cover_thumbnail'}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('UploadMulti',{attrs:{"entityId":_vm.item.id},on:{"uploaded":_vm.fetchItem}}),_vm._v(" "),_c('div',{staticClass:"photos-list"},[_vm._l((_vm.getPhotosList),function(photo){return _c('div',{key:photo.id,staticClass:"photo"},[_c('span',{staticClass:"remove-button",attrs:{"title":"remove photo"},on:{"click":function($event){_vm.removePhoto(photo.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("indeterminate_check_box")])]),_vm._v(" "),_c('img',{attrs:{"src":photo._thumbnail_mid,"alt":""}})])}),_vm._v(" "),_c('mugen-scroll',{attrs:{"handler":_vm.loadMorePhotosHandler,"should-handle":!_vm.loading}})],2)],1)])],1)],1)],1)}
var AlbumCreateEdit_staticRenderFns = []
var AlbumCreateEdit_esExports = { render: AlbumCreateEdit_render, staticRenderFns: AlbumCreateEdit_staticRenderFns }
/* harmony default export */ var profile_AlbumCreateEdit = (AlbumCreateEdit_esExports);
// CONCATENATED MODULE: ./src/pages/profile/AlbumCreateEdit.vue
function AlbumCreateEdit_injectStyle (ssrContext) {
  __webpack_require__("P/8s")
}
var AlbumCreateEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AlbumCreateEdit___vue_template_functional__ = false
/* styles */
var AlbumCreateEdit___vue_styles__ = AlbumCreateEdit_injectStyle
/* scopeId */
var AlbumCreateEdit___vue_scopeId__ = "data-v-1a16a0a4"
/* moduleIdentifier (server only) */
var AlbumCreateEdit___vue_module_identifier__ = null
var AlbumCreateEdit_Component = AlbumCreateEdit_normalizeComponent(
  AlbumCreateEdit,
  profile_AlbumCreateEdit,
  AlbumCreateEdit___vue_template_functional__,
  AlbumCreateEdit___vue_styles__,
  AlbumCreateEdit___vue_scopeId__,
  AlbumCreateEdit___vue_module_identifier__
)

/* harmony default export */ var pages_profile_AlbumCreateEdit = (AlbumCreateEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/TagViewEdit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var TagViewEdit = ({
  name: 'TagViewEdit',
  props: {
    item: {
      type: Object
    }
  },
  watch: {},
  data: function data() {
    return {
      loading: false,
      editmode: false,
      nameCopy: this.item.name
    };
  },

  methods: {
    onCancel: function onCancel() {
      this.editmode = false;
      this.nameCopy = this.item.name;
    },
    updateItem: function updateItem() {
      var _this = this;

      this.item.name = this.nameCopy;
      this.loading = true;
      tags_service_update(this.item.id, { name: this.item.name }).then(function (response) {
        _this.$emit('tag-updated');
        _this.$snotify.success('Tag is updated', 'All done!');
      }).catch(function (error) {
        _this.$snotify.error(error.message, 'Error');
        console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    },
    removeItem: function removeItem() {
      var _this2 = this;

      tags_service_remove(this.item.id).then(function (response) {
        _this2.$emit('tag-deleted');
        _this2.$snotify.success('Tag is deleted', 'All done!');
      }).catch(function (error) {
        _this2.$snotify.error(error.message, 'Error');
        console.log(error);
      });
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d36c62dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/TagViewEdit.vue
var TagViewEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-view-edit component"},[(_vm.editmode)?_c('div',{staticClass:"content editmode"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameCopy),expression:"nameCopy"}],attrs:{"type":"text"},domProps:{"value":(_vm.nameCopy)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nameCopy=$event.target.value}}}),_vm._v(" "),_c('md-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.updateItem}},[_vm._v("save")]),_vm._v(" "),_c('md-button',{on:{"click":_vm.onCancel}},[_vm._v("cancel")]),_vm._v(" "),_c('md-button',{on:{"click":_vm.removeItem}},[_vm._v("delete")])],1):_c('div',{staticClass:"content readmode"},[_c('div',{on:{"dblclick":function($event){_vm.editmode = true}}},[_vm._v(_vm._s(_vm.item.name))])])])}
var TagViewEdit_staticRenderFns = []
var TagViewEdit_esExports = { render: TagViewEdit_render, staticRenderFns: TagViewEdit_staticRenderFns }
/* harmony default export */ var profile_TagViewEdit = (TagViewEdit_esExports);
// CONCATENATED MODULE: ./src/pages/profile/TagViewEdit.vue
function TagViewEdit_injectStyle (ssrContext) {
  __webpack_require__("z/bq")
}
var TagViewEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagViewEdit___vue_template_functional__ = false
/* styles */
var TagViewEdit___vue_styles__ = TagViewEdit_injectStyle
/* scopeId */
var TagViewEdit___vue_scopeId__ = "data-v-d36c62dc"
/* moduleIdentifier (server only) */
var TagViewEdit___vue_module_identifier__ = null
var TagViewEdit_Component = TagViewEdit_normalizeComponent(
  TagViewEdit,
  profile_TagViewEdit,
  TagViewEdit___vue_template_functional__,
  TagViewEdit___vue_styles__,
  TagViewEdit___vue_scopeId__,
  TagViewEdit___vue_module_identifier__
)

/* harmony default export */ var pages_profile_TagViewEdit = (TagViewEdit_Component.exports);

// EXTERNAL MODULE: ./node_modules/slug/slug.js
var slug = __webpack_require__("ngKQ");
var slug_default = /*#__PURE__*/__webpack_require__.n(slug);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/TagCreate.vue
//
//
//
//
//
//
//
//
//




/* harmony default export */ var TagCreate = ({
  name: 'TagCreate',
  watch: {},
  data: function data() {
    return {
      error: false,
      loading: false,
      name: '',
      slugOptions: {
        lower: true,
        charmap: {
          '$': false // trim $
        }
      }

    };
  },


  methods: {
    /**
     * tag name will be stored as slug
     */
    createItem: function createItem() {
      var _this = this;

      if (this.slugName.length < 3) return;

      this.loading = true;
      tags_service_create({ name: this.slugName }).then(function (response) {
        _this.$snotify.success('Is created, All done!', 'Tag: ' + _this.slugName);
        _this.name = '';
        _this.$emit('tag-added');
      }).catch(function (error) {
        _this.$snotify.error(error.message, 'Error');
        console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    }
  },

  computed: {
    slugName: function slugName() {
      return slug_default()(this.name, this.slugOptions);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13535e97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/TagCreate.vue
var TagCreate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-create component"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","placeholder":"add new tag"},domProps:{"value":(_vm.name)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.createItem($event)},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.slugName)?_c('div',{staticClass:"slug"},[_vm._v("\n    Tag will be stored as slug: "),_c('b',[_vm._v(_vm._s(_vm.slugName))])]):_vm._e()])}
var TagCreate_staticRenderFns = []
var TagCreate_esExports = { render: TagCreate_render, staticRenderFns: TagCreate_staticRenderFns }
/* harmony default export */ var profile_TagCreate = (TagCreate_esExports);
// CONCATENATED MODULE: ./src/pages/profile/TagCreate.vue
function TagCreate_injectStyle (ssrContext) {
  __webpack_require__("LnKE")
}
var TagCreate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagCreate___vue_template_functional__ = false
/* styles */
var TagCreate___vue_styles__ = TagCreate_injectStyle
/* scopeId */
var TagCreate___vue_scopeId__ = "data-v-13535e97"
/* moduleIdentifier (server only) */
var TagCreate___vue_module_identifier__ = null
var TagCreate_Component = TagCreate_normalizeComponent(
  TagCreate,
  profile_TagCreate,
  TagCreate___vue_template_functional__,
  TagCreate___vue_styles__,
  TagCreate___vue_scopeId__,
  TagCreate___vue_module_identifier__
)

/* harmony default export */ var pages_profile_TagCreate = (TagCreate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/TagsList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var TagsList = ({
  name: 'TagsList',
  props: {
    limit: {
      type: Number,
      default: 20
    },
    page: {
      type: Number,
      default: 1
    }
  },
  components: {
    TagViewEdit: pages_profile_TagViewEdit,
    TagCreate: pages_profile_TagCreate
  },
  watch: {},
  data: function data() {
    return {
      loading: false,
      error: false,
      newTagName: '',
      query: '',
      tags: [],
      pagination: {
        page: this.page,
        limit: this.limit,
        total: 0
      }
    };
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loading = true;
      this.error = false;
      tags_service_getList().then(function (response) {
        _this.tags = response.data.content;
        _this.total = response.data.total;
      }).catch(function (error) {
        _this.error = error.message;
      }).finally(function () {
        _this.loading = false;
      });
    },
    searchHandler: function searchHandler() {
      var _this2 = this;

      this.loading = true;
      this.error = false;
      find({ q: this.query }).then(function (response) {
        _this2.tags = response.data.content;
        _this2.total = response.data.total;
      }).catch(function (error) {
        _this2.error = error.message;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.query = '';
      this.fetchData();
    }
  },
  computed: {
    isEmpty: function isEmpty() {
      return !this.tags.length;
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c8a190","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/TagsList.vue
var TagsList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-list page"},[_c('div',{staticClass:"search-form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"type":"text","placeholder":"search"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchHandler($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('md-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.resetSearch}},[_vm._v("reset")])],1),_vm._v(" "),_c('div',{staticClass:"add-new"},[_c('TagCreate',{on:{"tag-added":_vm.fetchData}})],1),_vm._v(" "),_c('UiDataBox',{attrs:{"loading":_vm.loading,"isEmpty":_vm.isEmpty,"error":_vm.error}},[_c('div',{staticClass:"tags-wrapper"},_vm._l((_vm.tags),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('TagViewEdit',{attrs:{"item":item},on:{"tag-updated":_vm.fetchData,"tag-deleted":_vm.fetchData}})],1)}))])],1)}
var TagsList_staticRenderFns = []
var TagsList_esExports = { render: TagsList_render, staticRenderFns: TagsList_staticRenderFns }
/* harmony default export */ var profile_TagsList = (TagsList_esExports);
// CONCATENATED MODULE: ./src/pages/profile/TagsList.vue
function TagsList_injectStyle (ssrContext) {
  __webpack_require__("qDU4")
}
var TagsList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagsList___vue_template_functional__ = false
/* styles */
var TagsList___vue_styles__ = TagsList_injectStyle
/* scopeId */
var TagsList___vue_scopeId__ = "data-v-15c8a190"
/* moduleIdentifier (server only) */
var TagsList___vue_module_identifier__ = null
var TagsList_Component = TagsList_normalizeComponent(
  TagsList,
  profile_TagsList,
  TagsList___vue_template_functional__,
  TagsList___vue_styles__,
  TagsList___vue_scopeId__,
  TagsList___vue_module_identifier__
)

/* harmony default export */ var pages_profile_TagsList = (TagsList_Component.exports);

// CONCATENATED MODULE: ./src/services/user.service.js




var user_service_ENTITY = 'users';

function user_service_getById(user_id) {
  return new promise_default.a(function (resolve, reject) {
    return new http_init_Http({ auth: true }).get(user_service_ENTITY + '/' + user_id).then(function (response) {
      resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      var message = error.response.data ? error.response.data.error : error.response.statusText;
      reject(new util_ErrorWrapper(error, message));
    });
  });
}

function user_service_update(id, data) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).patch(user_service_ENTITY + '/' + id, data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function user_service_changePassword(data) {
  if (!data.oldPassword || !data.newPassword) throw new Error('required oldPassword and newPassword params');

  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post(user_service_ENTITY + '/change-password', data).then(function (response) {
      return resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function getCurrent() {
  return new promise_default.a(function (resolve, reject) {
    return new http_init_Http({ auth: true }).get(user_service_ENTITY + '/current').then(function (response) {
      resolve(new util_ResponseWrapper(response, response.data.data));
    }).catch(function (error) {
      var message = error.response.data ? error.response.data.error : error.response.statusText;
      reject(new util_ErrorWrapper(error, message));
    });
  });
}

function getPostsByUserId(user_id) {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).get(user_service_ENTITY + '/' + user_id + '/posts').then(function (response) {
      var data = {
        content: response.data.data,
        total: response.data.data.total ? response.data.data.total : ''
      };
      resolve(new util_ResponseWrapper(response, data));
    }).catch(function (error) {
      var message = error.response.data ? error.response.data.error : error.response.statusText;
      reject(new util_ErrorWrapper(error, message));
    });
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/Settings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Settings = ({
  name: 'Settings',
  props: {},
  components: {},
  mixins: [mixins_setModelMixin],
  data: function data() {
    return {
      loading: false,
      error: false,
      user: {
        id: '',
        email: '',
        name: '',
        role: ''
      },
      password: {
        oldPassword: '',
        newPassword: '',
        repeatNewPassword: ''
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      var _this = this;

      this.loading = true;
      user_service_update(this.user.id, { name: this.user.name }).then(function (response) {
        _this.user = _this.setModelMixin(_this.user, response.data);
        _this.$snotify.success('Profile is saved', 'All done!');
      }).catch(function (error) {
        console.log(error);
        _this.$snotify.error(error.message, 'Error');
      }).finally(function () {
        _this.loading = false;
      });
    },
    changePassword: function changePassword() {
      var _this2 = this;

      var data = {
        oldPassword: this.password.oldPassword,
        newPassword: this.password.newPassword
      };

      this.loading = true;
      user_service_changePassword(data).then(function () {
        makeLogout();
        _this2.$snotify.success('Password is changed, please authorise again', 'All done!');
      }).catch(function (error) {
        console.log(error);
        _this2.$snotify.error(error.message, 'Error');
      }).finally(function () {
        _this2.loading = false;
      });
    }
  },
  computed: {
    isSaveProfileDisabled: function isSaveProfileDisabled() {
      return this.user.name.length < 3 || this.loading;
    },
    isSavePasswordDisabled: function isSavePasswordDisabled() {
      return this.password.newPassword.length < 8 || this.password.newPassword !== this.password.repeatNewPassword || this.loading;
    }
  },
  mounted: function mounted() {
    this.user = this.$currentUser;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-192d8781","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/Settings.vue
var Settings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings component"},[_c('UiDataBox',{attrs:{"loading":_vm.loading,"error":_vm.error}},[_c('section',{staticClass:"profile"},[_c('div',{staticClass:"title"},[_vm._v("Profile info:")]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',{attrs:{"for":"email"}},[_vm._v("email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],attrs:{"id":"email","type":"text","placeholder":"email","readonly":""},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',{attrs:{"for":"name"}},[_vm._v("name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],attrs:{"id":"name","type":"text","placeholder":"name"},domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',{attrs:{"for":"role"}},[_vm._v("role")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.role),expression:"user.role"}],attrs:{"id":"role","type":"text","placeholder":"role","readonly":""},domProps:{"value":(_vm.user.role)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "role", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control button"},[_c('md-button',{attrs:{"disabled":_vm.isSaveProfileDisabled},on:{"click":_vm.updateProfile}},[_vm._v("Save profile")])],1)]),_vm._v(" "),_c('section',{staticClass:"password"},[_c('div',{staticClass:"title"},[_vm._v("Change password:")]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',{attrs:{"for":"oldPassword"}},[_vm._v("old password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.oldPassword),expression:"password.oldPassword"}],attrs:{"id":"oldPassword","type":"password","placeholder":"password"},domProps:{"value":(_vm.password.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "oldPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',{attrs:{"for":"newPassword"}},[_vm._v("new password (8 characters min)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.newPassword),expression:"password.newPassword"}],attrs:{"id":"newPassword","type":"password","placeholder":"new password"},domProps:{"value":(_vm.password.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "newPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control"},[_c('label',{attrs:{"for":"repeatNewPassword"}},[_vm._v("repeat new password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.repeatNewPassword),expression:"password.repeatNewPassword"}],attrs:{"id":"repeatNewPassword","type":"password","placeholder":"repeat new password"},domProps:{"value":(_vm.password.repeatNewPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "repeatNewPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-control button"},[_c('md-button',{attrs:{"disabled":_vm.isSavePasswordDisabled},on:{"click":_vm.changePassword}},[_vm._v("Save password")])],1)])])],1)}
var Settings_staticRenderFns = []
var Settings_esExports = { render: Settings_render, staticRenderFns: Settings_staticRenderFns }
/* harmony default export */ var profile_Settings = (Settings_esExports);
// CONCATENATED MODULE: ./src/pages/profile/Settings.vue
function Settings_injectStyle (ssrContext) {
  __webpack_require__("Mmdl")
}
var Settings_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Settings___vue_template_functional__ = false
/* styles */
var Settings___vue_styles__ = Settings_injectStyle
/* scopeId */
var Settings___vue_scopeId__ = "data-v-192d8781"
/* moduleIdentifier (server only) */
var Settings___vue_module_identifier__ = null
var Settings_Component = Settings_normalizeComponent(
  Settings,
  profile_Settings,
  Settings___vue_template_functional__,
  Settings___vue_styles__,
  Settings___vue_scopeId__,
  Settings___vue_module_identifier__
)

/* harmony default export */ var pages_profile_Settings = (Settings_Component.exports);

// CONCATENATED MODULE: ./src/directives/debounce.js
function directive(el, binding) {
  if (binding.value !== binding.oldValue) {
    // change debounce only if interval has changed
    el.oninput = directive.debounce(function (evt) {
      el.dispatchEvent(new Event('debounce-change'));
    }, parseInt(binding.value) || 500);
  }
}

function debounce(fn, delay) {
  var _this = this,
      _arguments = arguments;

  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(function () {
      fn.apply(_this, _arguments);
    }, delay);
  };
}

directive.debounce = debounce;
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchByTag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var SearchByTag = ({
  name: 'SearchByTag',

  directives: {
    debounce: directive
  },

  data: function data() {
    return {
      loading: false,
      error: false,
      success: true,
      fullSize: false,
      query: '',
      tags: []
    };
  },


  methods: {
    onBlur: function onBlur() {
      var _this = this;

      setTimeout(function () {
        _this.fullSize = false;
        _this.query = '';
        _this.tags = [];
      }, 200);
    },
    onEsc: function onEsc() {
      this.$refs.search.blur();
    },
    searchTagHandler: function searchTagHandler() {
      var _this2 = this;

      this.tags = [];
      if (!this.query || this.query.length < 2) return;

      this.loading = true;
      find({ q: this.query }).then(function (response) {
        _this2.tags = response.data.content;
        _this2.success = response.success;
      }).catch(function (error) {
        _this2.error = error.message;
        _this2.success = error.success;
      }).finally(function (response) {
        return _this2.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f999416e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchByTag.vue
var SearchByTag_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-by-tag component"},[_c('div',{staticClass:"overlay",class:{'full-size': _vm.fullSize}},[_c('div',{staticClass:"content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"},{name:"debounce",rawName:"v-debounce",value:(1000),expression:"1000"}],ref:"search",class:{'full-size': _vm.fullSize},attrs:{"type":"text","placeholder":"search"},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.onEsc($event)},"blur":_vm.onBlur,"click":function($event){_vm.fullSize = true},"debounce-change":_vm.searchTagHandler,"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.fullSize)?_c('div',{staticClass:"result"},[_c('UiDataBox',{attrs:{"loading":_vm.loading}},[_vm._l((_vm.tags),function(tag){return (_vm.tags.length)?_c('div',{key:tag.id,staticClass:"tag"},[_c('router-link',{attrs:{"to":{ name: 'tag', params: { name: tag.name }}}},[_vm._v(_vm._s(tag.name))])],1):_vm._e()}),_vm._v(" "),(!_vm.tags.length && !_vm.success)?_c('div',{staticClass:"tag"},[_vm._v("\n            nope, nothing there\n          ")]):_vm._e()],2)],1):_vm._e()])])])}
var SearchByTag_staticRenderFns = []
var SearchByTag_esExports = { render: SearchByTag_render, staticRenderFns: SearchByTag_staticRenderFns }
/* harmony default export */ var components_SearchByTag = (SearchByTag_esExports);
// CONCATENATED MODULE: ./src/components/SearchByTag.vue
function SearchByTag_injectStyle (ssrContext) {
  __webpack_require__("lboT")
}
var SearchByTag_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchByTag___vue_template_functional__ = false
/* styles */
var SearchByTag___vue_styles__ = SearchByTag_injectStyle
/* scopeId */
var SearchByTag___vue_scopeId__ = "data-v-f999416e"
/* moduleIdentifier (server only) */
var SearchByTag___vue_module_identifier__ = null
var SearchByTag_Component = SearchByTag_normalizeComponent(
  SearchByTag,
  components_SearchByTag,
  SearchByTag___vue_template_functional__,
  SearchByTag___vue_styles__,
  SearchByTag___vue_scopeId__,
  SearchByTag___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchByTag = (SearchByTag_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PulseLoading.vue
//
//
//
//
//
//

/* harmony default export */ var PulseLoading = ({
  name: 'PulseLoading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e0cfae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PulseLoading.vue
var PulseLoading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var PulseLoading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pulse-loading component"},[_c('div',{staticClass:"sk-spinner sk-spinner-pulse"})])}]
var PulseLoading_esExports = { render: PulseLoading_render, staticRenderFns: PulseLoading_staticRenderFns }
/* harmony default export */ var components_PulseLoading = (PulseLoading_esExports);
// CONCATENATED MODULE: ./src/components/PulseLoading.vue
function PulseLoading_injectStyle (ssrContext) {
  __webpack_require__("bFOC")
}
var PulseLoading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PulseLoading___vue_template_functional__ = false
/* styles */
var PulseLoading___vue_styles__ = PulseLoading_injectStyle
/* scopeId */
var PulseLoading___vue_scopeId__ = "data-v-51e0cfae"
/* moduleIdentifier (server only) */
var PulseLoading___vue_module_identifier__ = null
var PulseLoading_Component = PulseLoading_normalizeComponent(
  PulseLoading,
  components_PulseLoading,
  PulseLoading___vue_template_functional__,
  PulseLoading___vue_styles__,
  PulseLoading___vue_scopeId__,
  PulseLoading___vue_module_identifier__
)

/* harmony default export */ var src_components_PulseLoading = (PulseLoading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ImgLoader.vue
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @description Component check image loading status and show loading animation if image still not loaded
 */


/* harmony default export */ var ImgLoader = ({
  name: 'ImgLoader',
  components: {
    PulseLoading: src_components_PulseLoading
  },
  props: {
    alt: {
      type: String
    },
    src: {
      type: String,
      required: true
    },
    animated: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    src: {
      handler: 'checkLoadingStatus',
      immediate: true
    }
  },

  data: function data() {
    return {
      loading: true,
      error: false
    };
  },


  methods: {
    checkLoadingStatus: function checkLoadingStatus() {
      var _this = this;

      this.loading = true;
      var interval = setInterval(function () {
        if (_this.$refs.image && _this.$refs.image.complete) {
          _this.loading = false;
          clearInterval(interval);
        }
      }, 250);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e019d628","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImgLoader.vue
var ImgLoader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-loader component"},[_c('div',{staticClass:"img-container",class:{'is-loaded': !_vm.loading, 'is-animated': _vm.animated}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"image",attrs:{"src":_vm.src,"alt":_vm.alt}})]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('PulseLoading')],1):_vm._e()])}
var ImgLoader_staticRenderFns = []
var ImgLoader_esExports = { render: ImgLoader_render, staticRenderFns: ImgLoader_staticRenderFns }
/* harmony default export */ var components_ImgLoader = (ImgLoader_esExports);
// CONCATENATED MODULE: ./src/components/ImgLoader.vue
function ImgLoader_injectStyle (ssrContext) {
  __webpack_require__("tcXH")
}
var ImgLoader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ImgLoader___vue_template_functional__ = false
/* styles */
var ImgLoader___vue_styles__ = ImgLoader_injectStyle
/* scopeId */
var ImgLoader___vue_scopeId__ = "data-v-e019d628"
/* moduleIdentifier (server only) */
var ImgLoader___vue_module_identifier__ = null
var ImgLoader_Component = ImgLoader_normalizeComponent(
  ImgLoader,
  components_ImgLoader,
  ImgLoader___vue_template_functional__,
  ImgLoader___vue_styles__,
  ImgLoader___vue_scopeId__,
  ImgLoader___vue_module_identifier__
)

/* harmony default export */ var src_components_ImgLoader = (ImgLoader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/gallery/AlbumList.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var AlbumList = ({
  name: 'AlbumList',
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    ImgLoader: src_components_ImgLoader
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9d29454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/gallery/AlbumList.vue
var AlbumList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component albums-list"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"album"},[_c('router-link',{attrs:{"to":{ name: 'album-view', params: { albumId: item.id } }}},[_c('ImgLoader',{attrs:{"src":item._cover_thumbnail,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.event_date)?_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.$moment(item.event_date).format(_vm.$FORMAT_DATETIME.DATE)))]):_vm._e()],1)],1)}))}
var AlbumList_staticRenderFns = []
var AlbumList_esExports = { render: AlbumList_render, staticRenderFns: AlbumList_staticRenderFns }
/* harmony default export */ var gallery_AlbumList = (AlbumList_esExports);
// CONCATENATED MODULE: ./src/pages/gallery/AlbumList.vue
function AlbumList_injectStyle (ssrContext) {
  __webpack_require__("a6mb")
}
var AlbumList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AlbumList___vue_template_functional__ = false
/* styles */
var AlbumList___vue_styles__ = AlbumList_injectStyle
/* scopeId */
var AlbumList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AlbumList___vue_module_identifier__ = null
var AlbumList_Component = AlbumList_normalizeComponent(
  AlbumList,
  gallery_AlbumList,
  AlbumList___vue_template_functional__,
  AlbumList___vue_styles__,
  AlbumList___vue_scopeId__,
  AlbumList___vue_module_identifier__
)

/* harmony default export */ var pages_gallery_AlbumList = (AlbumList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/gallery/Gallery.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Gallery = ({
  name: 'Gallery',
  props: {
    limit: {
      type: Number,
      default: 10
    },
    page: {
      type: Number,
      default: 0
    }
  },
  mixins: [mixins_prepareFetchParamsMixin],
  components: {
    Pagination: src_components_Pagination,
    SearchByTag: src_components_SearchByTag,
    AlbumList: pages_gallery_AlbumList
  },

  watch: {
    'pagination.page': function paginationPage() {
      this.fetchData();
    }
  },

  data: function data() {
    return {
      loading: false,
      error: false,
      albums: [],
      searchQuery: '',
      pagination: {
        page: this.page,
        limit: this.limit,
        total: 0
      }
    };
  },


  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loading = true;
      getListPublic(this.fetchParams).then(function (response) {
        _this.albums = response.data.content;
        _this.pagination.total = response.data.total;
      }).catch(function (error) {
        _this.error = error.message;
      }).finally(function () {
        _this.loading = false;
      });
    }
  },

  computed: {
    fetchParams: function fetchParams() {
      var pagination = this.prepareFetchParamsMixin({
        page: this.pagination.page,
        limit: this.pagination.limit
      });

      /*
      order example
      const order = this.prepareFetchParamsMixin({
        name: 'desc'
      })
      return { ...pagination, order }
      */

      return extends_default()({}, pagination);
    },
    isEmpty: function isEmpty() {
      return !this.albums.length;
    }
  },

  created: function created() {
    this.fetchData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c66f09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/gallery/Gallery.vue
var Gallery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery page"},[_c('div',{staticClass:"search-wrapper"},[_c('div',{staticClass:"search"},[_c('SearchByTag')],1)]),_vm._v(" "),_c('UiDataBox',{attrs:{"loading":_vm.loading,"isEmpty":_vm.isEmpty,"error":_vm.error}},[_c('AlbumList',{attrs:{"items":_vm.albums}}),_vm._v(" "),_c('Pagination',{attrs:{"total":_vm.pagination.total,"limit":_vm.pagination.limit,"page":_vm.pagination.page},on:{"update:page":function($event){_vm.$set(_vm.pagination, "page", $event)}}})],1)],1)}
var Gallery_staticRenderFns = []
var Gallery_esExports = { render: Gallery_render, staticRenderFns: Gallery_staticRenderFns }
/* harmony default export */ var gallery_Gallery = (Gallery_esExports);
// CONCATENATED MODULE: ./src/pages/gallery/Gallery.vue
function Gallery_injectStyle (ssrContext) {
  __webpack_require__("CvRq")
}
var Gallery_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Gallery___vue_template_functional__ = false
/* styles */
var Gallery___vue_styles__ = Gallery_injectStyle
/* scopeId */
var Gallery___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Gallery___vue_module_identifier__ = null
var Gallery_Component = Gallery_normalizeComponent(
  Gallery,
  gallery_Gallery,
  Gallery___vue_template_functional__,
  Gallery___vue_styles__,
  Gallery___vue_scopeId__,
  Gallery___vue_module_identifier__
)

/* harmony default export */ var pages_gallery_Gallery = (Gallery_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/album/Album.vue
//
//
//
//
//
//

/* harmony default export */ var Album = ({
  name: 'Album',
  props: {},
  components: {},
  watch: {},
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec78f58e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/album/Album.vue
var Album_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"album page"},[_c('router-view')],1)}
var Album_staticRenderFns = []
var Album_esExports = { render: Album_render, staticRenderFns: Album_staticRenderFns }
/* harmony default export */ var album_Album = (Album_esExports);
// CONCATENATED MODULE: ./src/pages/album/Album.vue
function Album_injectStyle (ssrContext) {
  __webpack_require__("kfjf")
}
var Album_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Album___vue_template_functional__ = false
/* styles */
var Album___vue_styles__ = Album_injectStyle
/* scopeId */
var Album___vue_scopeId__ = "data-v-ec78f58e"
/* moduleIdentifier (server only) */
var Album___vue_module_identifier__ = null
var Album_Component = Album_normalizeComponent(
  Album,
  album_Album,
  Album___vue_template_functional__,
  Album___vue_styles__,
  Album___vue_scopeId__,
  Album___vue_module_identifier__
)

/* harmony default export */ var pages_album_Album = (Album_Component.exports);

// CONCATENATED MODULE: ./src/mixins/setPageTitle.js
/* harmony default export */ var setPageTitle = ({
  methods: {
    setPageTitle: function setPageTitle(title) {
      window.document.title += " | " + title.toLowerCase();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TagsView.vue

//
//
//
//
//
//
//
//

/* harmony default export */ var TagsView = ({
  name: 'TagsView',
  props: {
    tagsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelName: {
      type: String,
      default: 'label'
    }
  },
  computed: {
    tags: function tags() {
      var _this = this;

      return this.tagsList.map(function (item) {
        return extends_default()({ label: item[_this.labelName] }, item);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a86835","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsView.vue
var TagsView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-view component"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.id,staticClass:"tag"},[_c('router-link',{attrs:{"to":{ name: 'tag', params: { name: tag.name }}}},[_vm._v(_vm._s(tag.label)),_c('span',{staticClass:"comma"},[_vm._v(",")])])],1)}))}
var TagsView_staticRenderFns = []
var TagsView_esExports = { render: TagsView_render, staticRenderFns: TagsView_staticRenderFns }
/* harmony default export */ var components_TagsView = (TagsView_esExports);
// CONCATENATED MODULE: ./src/components/TagsView.vue
function TagsView_injectStyle (ssrContext) {
  __webpack_require__("wGQz")
}
var TagsView_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagsView___vue_template_functional__ = false
/* styles */
var TagsView___vue_styles__ = TagsView_injectStyle
/* scopeId */
var TagsView___vue_scopeId__ = "data-v-22a86835"
/* moduleIdentifier (server only) */
var TagsView___vue_module_identifier__ = null
var TagsView_Component = TagsView_normalizeComponent(
  TagsView,
  components_TagsView,
  TagsView___vue_template_functional__,
  TagsView___vue_styles__,
  TagsView___vue_scopeId__,
  TagsView___vue_module_identifier__
)

/* harmony default export */ var src_components_TagsView = (TagsView_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SpinnerWave.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SpinnerWave = ({
  name: 'SpinnerWave'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d33d750","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpinnerWave.vue
var SpinnerWave_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var SpinnerWave_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-wave component"},[_c('div',{staticClass:"sk-wave"},[_c('div',{staticClass:"sk-rect sk-rect1 loading_color"}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect2 loading_color"}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect3 loading_color"}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect4 loading_color"}),_vm._v(" "),_c('div',{staticClass:"sk-rect sk-rect5 loading_color"})])])}]
var SpinnerWave_esExports = { render: SpinnerWave_render, staticRenderFns: SpinnerWave_staticRenderFns }
/* harmony default export */ var components_SpinnerWave = (SpinnerWave_esExports);
// CONCATENATED MODULE: ./src/components/SpinnerWave.vue
function SpinnerWave_injectStyle (ssrContext) {
  __webpack_require__("0184")
}
var SpinnerWave_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SpinnerWave___vue_template_functional__ = false
/* styles */
var SpinnerWave___vue_styles__ = SpinnerWave_injectStyle
/* scopeId */
var SpinnerWave___vue_scopeId__ = "data-v-9d33d750"
/* moduleIdentifier (server only) */
var SpinnerWave___vue_module_identifier__ = null
var SpinnerWave_Component = SpinnerWave_normalizeComponent(
  SpinnerWave,
  components_SpinnerWave,
  SpinnerWave___vue_template_functional__,
  SpinnerWave___vue_styles__,
  SpinnerWave___vue_scopeId__,
  SpinnerWave___vue_module_identifier__
)

/* harmony default export */ var src_components_SpinnerWave = (SpinnerWave_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/album/PhotoList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var PhotoList = ({
  name: 'PhotoList',
  mixins: [mixins_setModelMixin, setPageTitle],
  props: ['albumId'],
  components: {
    TagsView: src_components_TagsView,
    ImgLoader: src_components_ImgLoader,
    MugenScroll: vue_mugen_scroll_common_default.a,
    SpinnerWave: src_components_SpinnerWave
  },
  data: function data() {
    return {
      loading: false,
      error: false,
      infoContentHeight: '',
      photoArrayLimiter: 20,

      slugOptions: {
        lower: true,
        charmap: {
          '$': false // trim $
        }
      },

      item: {
        id: '',
        user_id: '',
        title: '',
        description: '',
        private: '',
        event_location: '',
        event_date: '',
        created_at: '',
        _cover_thumbnail: '',
        _cover_index: '',
        tags: [],
        photos: []
      }
    };
  },


  methods: {
    fetchItem: function fetchItem() {
      var _this = this;

      this.loading = true;
      getById(this.albumId).then(function (response) {
        _this.item = _this.setModelMixin(_this.item, response.data);
        _this.$store.commit('SET_CURRENT_ALBUM', response.data.photos);
        _this.setPageTitle(_this.item.title);
      }).catch(function (error) {
        return console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    },
    setInfoContentHeight: function setInfoContentHeight() {
      this.infoContentHeight = this.$refs.infoContent.offsetHeight;
    },
    loadMorePhotosHandler: function loadMorePhotosHandler() {
      if (this.photoArrayLimiter > this.item.photos.length) return;
      this.photoArrayLimiter += 8;
    }
  },

  computed: {
    isEmpty: function isEmpty() {
      return !this.item.photos.length;
    },
    isLoadingMorePhotos: function isLoadingMorePhotos() {
      return this.photoArrayLimiter < this.item.photos.length;
    },
    tagsList: function tagsList() {
      return this.item.tags.map(function (item) {
        return item.name;
      });
    },
    bgImage: function bgImage() {
      return '\n        ' + (this.item._cover_index ? 'background-image: url(' + this.item._cover_index + ');' : '') + '\n        height: ' + this.infoContentHeight + 'px;\n        background-size: cover;\n        background-position: center;';
    },
    getMinPhotoWidth: function getMinPhotoWidth() {
      return this.$refs.page.offsetWidth / 4 / 1.52;
    },
    getPhotosList: function getPhotosList() {
      return this.item.photos.slice(0, this.photoArrayLimiter);
    },
    viewsCount: function viewsCount() {
      return this.item.photos.map(function (_ref) {
        var views = _ref.views;
        return views;
      }).reduce(function (acc, next) {
        return acc + next;
      }, 0);
    },
    urlHash: function urlHash() {
      return slug_default()(this.item.title, this.slugOptions);
    }
  },

  created: function created() {
    this.fetchItem();
  },
  updated: function updated() {
    this.setInfoContentHeight();
    this.$router.replace({
      hash: this.urlHash
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1686d670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/album/PhotoList.vue
var PhotoList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"page",staticClass:"photo-list component"},[_c('UiDataBox',{attrs:{"loading":_vm.loading,"isEmpty":_vm.isEmpty,"error":_vm.error}},[_c('div',{staticClass:"info BOLD",style:(_vm.bgImage)},[_c('div',{ref:"infoContent",staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('div',{staticClass:"tags-data-wrapper"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.$moment(_vm.item.event_date).format(_vm.$FORMAT_DATETIME.DATE))+" "),_c('span',{staticClass:"divider"},[_vm._v("|")])]),_vm._v(" "),_c('TagsView',{staticClass:"tags-tablet",attrs:{"tagsList":_vm.item.tags,"labelName":"name"}}),_vm._v(" "),(_vm.viewsCount)?_c('div',{staticClass:"views-count"},[_c('span',{staticClass:"divider"},[_vm._v("|")]),_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")]),_vm._v(_vm._s(_vm.viewsCount))]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"photos"},_vm._l((_vm.getPhotosList),function(photo){return _c('div',{key:photo.id,staticClass:"photo",style:(("min-height: " + _vm.getMinPhotoWidth + "px"))},[_c('router-link',{attrs:{"to":{name: 'photo-view', params: {photoId: photo.id}}}},[_c('ImgLoader',{attrs:{"src":photo._thumbnail_mid,"animated":""}})],1)],1)}))]),_vm._v(" "),_c('mugen-scroll',{attrs:{"handler":_vm.loadMorePhotosHandler,"should-handle":!_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"total-photos FONT_TITLE BOLD"},[_vm._v(_vm._s(_vm.getPhotosList.length)+" / "+_vm._s(_vm.item.photos.length))]),_vm._v(" "),(_vm.isLoadingMorePhotos)?_c('SpinnerWave',{staticClass:"loading-more-photos"}):_vm._e()],1)],1)}
var PhotoList_staticRenderFns = []
var PhotoList_esExports = { render: PhotoList_render, staticRenderFns: PhotoList_staticRenderFns }
/* harmony default export */ var album_PhotoList = (PhotoList_esExports);
// CONCATENATED MODULE: ./src/pages/album/PhotoList.vue
function PhotoList_injectStyle (ssrContext) {
  __webpack_require__("ITo8")
}
var PhotoList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PhotoList___vue_template_functional__ = false
/* styles */
var PhotoList___vue_styles__ = PhotoList_injectStyle
/* scopeId */
var PhotoList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PhotoList___vue_module_identifier__ = null
var PhotoList_Component = PhotoList_normalizeComponent(
  PhotoList,
  album_PhotoList,
  PhotoList___vue_template_functional__,
  PhotoList___vue_styles__,
  PhotoList___vue_scopeId__,
  PhotoList___vue_module_identifier__
)

/* harmony default export */ var pages_album_PhotoList = (PhotoList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/album/PhotoModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var PhotoModal = ({
  name: 'PhotoModal',
  mixins: [mixins_setModelMixin],
  components: {
    ImgLoader: src_components_ImgLoader
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: false
    },
    photoId: {
      type: Number
    }
  },
  watch: {
    show: function show(newVal) {
      this.showLocal = newVal;
    },
    photoId: function photoId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchItem();
      }
    }
  },

  data: function data() {
    return {
      showLocal: this.show,
      loading: false,
      error: false,
      item: {
        _src: ''
      }
    };
  },


  computed: {
    albumList: function albumList() {
      return this.$store.state.currentAlbum.map(function (item) {
        return item.id;
      });
    },
    currentPhotoIndex: function currentPhotoIndex() {
      return this.albumList.indexOf(this.photoId);
    },
    getPreviousPhotoId: function getPreviousPhotoId() {
      var previousId = this.albumList[this.currentPhotoIndex - 1];
      var lastId = this.albumList[this.albumList.length - 1];
      return previousId || lastId;
    },
    getNextPhotoId: function getNextPhotoId() {
      var nextId = this.albumList[this.currentPhotoIndex + 1];
      var firstId = this.albumList[0];
      return nextId || firstId;
    }
  },

  methods: {
    fetchItem: function fetchItem() {
      var _this = this;

      this.loading = true;
      photos_service_getById(this.photoId).then(function (response) {
        _this.item = _this.setModelMixin(_this.item, response.data);
      }).catch(function (error) {
        _this.error = error.message;
        console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    },

    /**
     * при условии что если юзер перешол по прямой ссылке,
     * например http://localhost:8080/gallery/album/318/photo/59
     * мы сталкиваемся с проблемой что сущьность альбома еще не загружена
     *
     * для решения чего необходимо перед загрузкой сущьности фотографии загрузить сущьность альбома
     * далее по полученному списку фотографий мы сможем определить индекс текущей, слудующей и предудущей фотографий
     * и отобразить необходимые Id в ссылках (next/prev)
     */
    fetchAndInitAlbum: function fetchAndInitAlbum() {
      var _this2 = this;

      this.loading = true;
      getById(this.$route.params.albumId).then(function (response) {
        return _this2.$store.commit('SET_CURRENT_ALBUM', response.data.photos);
      }).then(function () {
        return _this2.fetchItem();
      }).catch(function (error) {
        return console.log(error);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    close: function close() {
      this.$emit('close');
    },
    onClickOverlay: function onClickOverlay($event) {
      if (this.closeOnOverlay && $event && $event.target === this.$refs.overlay) {
        this.close();
      }
    },
    goToPreviousPhoto: function goToPreviousPhoto() {
      this.$router.push({ name: 'photo-view', params: { photoId: this.getPreviousPhotoId } });
    },
    goToNextPhoto: function goToNextPhoto() {
      this.$router.push({ name: 'photo-view', params: { photoId: this.getNextPhotoId } });
    }
  },

  mounted: function mounted() {
    if (!this.albumList.length) {
      this.fetchAndInitAlbum();
    } else {
      this.fetchItem();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db8f9d48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/album/PhotoModal.vue
var PhotoModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[(_vm.showLocal)?_c('div',{ref:"overlay",staticClass:"photo-modal overlay component",on:{"click":_vm.onClickOverlay}},[(this.albumList.length)?_c('div',{staticClass:"modal-content"},[_c('UiDataBox',{attrs:{"loading":_vm.loading,"error":_vm.error}},[(_vm.showCloseButton && !_vm.loading)?_c('i',{directives:[{name:"shortkey",rawName:"v-shortkey",value:(['esc']),expression:"['esc']"}],staticClass:"close",on:{"click":_vm.close,"shortkey":_vm.close}}):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"shortkey",rawName:"v-shortkey",value:(['arrowleft']),expression:"['arrowleft']"}],staticClass:"prev",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToPreviousPhoto($event)},"shortkey":_vm.goToPreviousPhoto}},[_c('i',{staticClass:"ico"})]),_vm._v(" "),_c('a',{directives:[{name:"shortkey",rawName:"v-shortkey",value:(['arrowright']),expression:"['arrowright']"}],staticClass:"next",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.goToNextPhoto($event)},"shortkey":_vm.goToNextPhoto}},[_c('i',{staticClass:"ico"})]),_vm._v(" "),_c('ImgLoader',{attrs:{"src":_vm.item._src,"animated":""}})],1)],1):_vm._e()]):_vm._e()])}
var PhotoModal_staticRenderFns = []
var PhotoModal_esExports = { render: PhotoModal_render, staticRenderFns: PhotoModal_staticRenderFns }
/* harmony default export */ var album_PhotoModal = (PhotoModal_esExports);
// CONCATENATED MODULE: ./src/pages/album/PhotoModal.vue
function PhotoModal_injectStyle (ssrContext) {
  __webpack_require__("k+3Y")
}
var PhotoModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PhotoModal___vue_template_functional__ = false
/* styles */
var PhotoModal___vue_styles__ = PhotoModal_injectStyle
/* scopeId */
var PhotoModal___vue_scopeId__ = "data-v-db8f9d48"
/* moduleIdentifier (server only) */
var PhotoModal___vue_module_identifier__ = null
var PhotoModal_Component = PhotoModal_normalizeComponent(
  PhotoModal,
  album_PhotoModal,
  PhotoModal___vue_template_functional__,
  PhotoModal___vue_styles__,
  PhotoModal___vue_scopeId__,
  PhotoModal___vue_module_identifier__
)

/* harmony default export */ var pages_album_PhotoModal = (PhotoModal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/album/Photo.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Photo = ({
  name: 'Photo',
  props: ['albumId', 'photoId'],
  components: {
    ModalPhotoView: pages_album_PhotoModal
  },
  data: function data() {
    return {
      isShownModalPhoto: true
    };
  },

  methods: {
    onCloseModal: function onCloseModal() {
      this.$router.push({ name: 'album-view', params: { albumId: this.albumId } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a884f84c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/album/Photo.vue
var Photo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo component"},[_c('ModalPhotoView',{attrs:{"closeOnOverlay":"","photoId":+_vm.photoId,"show":_vm.isShownModalPhoto},on:{"close":_vm.onCloseModal}})],1)}
var Photo_staticRenderFns = []
var Photo_esExports = { render: Photo_render, staticRenderFns: Photo_staticRenderFns }
/* harmony default export */ var album_Photo = (Photo_esExports);
// CONCATENATED MODULE: ./src/pages/album/Photo.vue
function Photo_injectStyle (ssrContext) {
  __webpack_require__("SYG6")
}
var Photo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Photo___vue_template_functional__ = false
/* styles */
var Photo___vue_styles__ = Photo_injectStyle
/* scopeId */
var Photo___vue_scopeId__ = "data-v-a884f84c"
/* moduleIdentifier (server only) */
var Photo___vue_module_identifier__ = null
var Photo_Component = Photo_normalizeComponent(
  Photo,
  album_Photo,
  Photo___vue_template_functional__,
  Photo___vue_styles__,
  Photo___vue_scopeId__,
  Photo___vue_module_identifier__
)

/* harmony default export */ var pages_album_Photo = (Photo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Tag.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Tag = ({
  name: 'Tag',
  props: {
    limit: {
      type: Number,
      'default': 20
    },
    page: {
      type: Number,
      'default': 0
    }
  },
  components: {
    AlbumList: pages_gallery_AlbumList,
    Pagination: src_components_Pagination
  },
  mixins: [mixins_setModelMixin, mixins_prepareFetchParamsMixin, setPageTitle],
  data: function data() {
    return {
      loading: false,
      errorTag: false,
      errorAlbumsList: false,
      item: {
        id: '',
        name: ''
      },
      albums: [],
      pagination: {
        total: 0,
        page: this.page,
        limit: this.limit
      }
    };
  },


  methods: {
    fetchTag: function fetchTag() {
      var _this = this;

      this.loading = true;
      getByName(this.$route.params.name).then(function (response) {
        _this.item = _this.setModelMixin(_this.item, response.data);
        _this.setPageTitle(_this.item.name);
      }).then(function () {
        return _this.fetchAlbumsByTagId();
      }).catch(function (error) {
        _this.errorTag = error.message;
        console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    },
    fetchAlbumsByTagId: function fetchAlbumsByTagId() {
      var _this2 = this;

      this.loading = true;
      getAlbumsByTagId(this.item.id, this.getFetchParams).then(function (response) {
        _this2.albums = response.data.content;
        _this2.pagination.total = response.data.total;
      }).catch(function (error) {
        _this2.errorAlbumsList = error.message;
        console.log(error);
      }).finally(function () {
        _this2.loading = false;
      });
    }
  },

  computed: {
    getFetchParams: function getFetchParams() {
      var pagination = this.prepareFetchParamsMixin({
        page: this.pagination.page,
        limit: this.pagination.limit
      });

      return extends_default()({}, pagination);
    },
    isTagNotFound: function isTagNotFound() {
      return !keys_default()(this.item).length;
    },
    isEmptyAlbums: function isEmptyAlbums() {
      return !this.albums.length;
    }
  },

  mounted: function mounted() {
    this.fetchTag();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2496e518","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tag.vue
var Tag_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag page"},[_c('UiDataBox',{attrs:{"loading":_vm.loading,"isEmpty":_vm.isTagNotFound,"error":_vm.errorTag}},[_c('div',{staticClass:"head BOLD"},[_vm._v("#"+_vm._s(_vm.item.name)+" ")])]),_vm._v(" "),(_vm.item.id)?_c('UiDataBox',{attrs:{"loading":_vm.loading,"isEmpty":_vm.isEmptyAlbums,"error":_vm.errorAlbumsList}},[_c('AlbumList',{attrs:{"items":_vm.albums}}),_vm._v(" "),_c('Pagination',{attrs:{"total":_vm.pagination.total,"limit":_vm.pagination.limit,"page":_vm.pagination.page},on:{"update:page":function($event){_vm.$set(_vm.pagination, "page", $event)}}})],1):_vm._e()],1)}
var Tag_staticRenderFns = []
var Tag_esExports = { render: Tag_render, staticRenderFns: Tag_staticRenderFns }
/* harmony default export */ var pages_Tag = (Tag_esExports);
// CONCATENATED MODULE: ./src/pages/Tag.vue
function Tag_injectStyle (ssrContext) {
  __webpack_require__("sKjR")
}
var Tag_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tag___vue_template_functional__ = false
/* styles */
var Tag___vue_styles__ = Tag_injectStyle
/* scopeId */
var Tag___vue_scopeId__ = "data-v-2496e518"
/* moduleIdentifier (server only) */
var Tag___vue_module_identifier__ = null
var Tag_Component = Tag_normalizeComponent(
  Tag,
  pages_Tag,
  Tag___vue_template_functional__,
  Tag___vue_styles__,
  Tag___vue_scopeId__,
  Tag___vue_module_identifier__
)

/* harmony default export */ var src_pages_Tag = (Tag_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Home = ({
  name: 'Index',
  mixins: [mixins_setModelMixin],
  components: {
    TagsView: src_components_TagsView,
    ImgLoader: src_components_ImgLoader
  },
  data: function data() {
    return {
      loading: false,
      error: false,
      titleFontSize: {},
      tagsFontSize: {},
      dateFontSize: {},
      blockHeight: {},
      item: {
        id: null,
        user_id: '',
        title: '',
        description: '',
        private: '',
        event_location: '',
        event_date: '',
        created_at: '',
        _cover_thumbnail: '',
        _cover_index: '',
        tags: []
      }
    };
  },


  methods: {
    setStyle: function setStyle() {
      this.titleFontSize = { 'font-size': this.getPageWidth() * 70 / 1000 + 'px' };
      this.tagsFontSize = { 'font-size': this.getPageWidth() * 15 / 1000 + 'px' };
      this.dateFontSize = { 'font-size': this.getPageWidth() * 25 / 1000 + 'px' };
      this.blockHeight = { 'height': parseInt(this.getPageWidth() / 2.33) + 'px' };
    },
    getPageWidth: function getPageWidth() {
      return this.$refs.page ? this.$refs.page.offsetWidth : 1280;
    },
    fetchLastAlbum: function fetchLastAlbum() {
      var _this = this;

      this.loading = true;
      getLast().then(function (response) {
        _this.item = _this.setModelMixin(_this.item, response.data);
      }).catch(function (error) {
        _this.error = error.message;
        console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('resize', function () {
      return _this2.setStyle();
    });
    this.setStyle();
    this.fetchLastAlbum();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daada922","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"page",staticClass:"home page",style:(_vm.blockHeight)},[_c('UiDataBox',{attrs:{"loading":_vm.loading,"error":_vm.error}},[(_vm.item.id)?_c('div',{staticClass:"index-image"},[_c('div',{staticClass:"info top"},[_c('div',{staticClass:"title",style:(_vm.titleFontSize)},[_c('router-link',{staticClass:"title link",attrs:{"to":{ name: 'album-view', params: {albumId: _vm.item.id} }}},[_vm._v(_vm._s(_vm.item.title))])],1),_vm._v(" "),_c('div',{staticClass:"tags-wrapper",style:(_vm.tagsFontSize)},[_c('TagsView',{attrs:{"tagsList":_vm.item.tags,"labelName":"name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"info bottom BOLD",style:(_vm.dateFontSize)},[_vm._v("\n        "+_vm._s(_vm.$moment(_vm.item.event_date).format(_vm.$FORMAT_DATETIME.DATE))+"\n      ")]),_vm._v(" "),_c('ImgLoader',{attrs:{"src":_vm.item._cover_index}})],1):_vm._e()])],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/pages/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("mP6D")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-daada922"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_pages_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./src/services/news.service.js



var news = [{
  id: 0,
  title: 'Начало редизайна/разработки проекта',
  content: '',
  date: '25/11/2017'
}, {
  id: 1,
  title: 'Первая публичная бета',
  content: '',
  date: '02/03/2018'
}];

function news_service_getList() {
  return promise_default.a.resolve(news).then(function (data) {
    var response = { data: data };
    return new util_ResponseWrapper(response, response.data);
  }).catch(function (error) {
    return new util_ErrorWrapper(error);
  });
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/News.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var News = ({
  name: 'News',
  data: function data() {
    return {
      loading: false,
      news: []
    };
  },


  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loading = true;
      news_service_getList().then(function (response) {
        _this.news = response.data;
      }).catch(function (error) {
        return console.log(error);
      }).finally(function () {
        _this.loading = false;
      });
    }
  },

  created: function created() {
    this.fetchData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dec5968","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/News.vue
var News_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news page"},[_c('div',{staticClass:"news-list"},_vm._l((_vm.news),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(item.content)?_c('div',{staticClass:"content"},[_vm._v(_vm._s(item.content))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(item.date))])])}))])}
var News_staticRenderFns = []
var News_esExports = { render: News_render, staticRenderFns: News_staticRenderFns }
/* harmony default export */ var pages_News = (News_esExports);
// CONCATENATED MODULE: ./src/pages/News.vue
function News_injectStyle (ssrContext) {
  __webpack_require__("Wrda")
}
var News_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var News___vue_template_functional__ = false
/* styles */
var News___vue_styles__ = News_injectStyle
/* scopeId */
var News___vue_scopeId__ = "data-v-3dec5968"
/* moduleIdentifier (server only) */
var News___vue_module_identifier__ = null
var News_Component = News_normalizeComponent(
  News,
  pages_News,
  News___vue_template_functional__,
  News___vue_styles__,
  News___vue_scopeId__,
  News___vue_module_identifier__
)

/* harmony default export */ var src_pages_News = (News_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Contact.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Contact = ({
  name: 'Contact'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f7f29f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
var Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Contact_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact page"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("email me: "),_c('a',{attrs:{"href":"mailto:dewhite@whiteside.in.ua"}},[_vm._v("dewhite@whiteside.in.ua")])]),_vm._v(" "),_c('p',[_vm._v("or text: "),_c('a',{attrs:{"href":"https://www.facebook.com/sash.whiteside"}},[_vm._v("fb.com/sash.whiteside")])])])])}]
var Contact_esExports = { render: Contact_render, staticRenderFns: Contact_staticRenderFns }
/* harmony default export */ var pages_Contact = (Contact_esExports);
// CONCATENATED MODULE: ./src/pages/Contact.vue
function Contact_injectStyle (ssrContext) {
  __webpack_require__("mCkW")
}
var Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Contact___vue_template_functional__ = false
/* styles */
var Contact___vue_styles__ = Contact_injectStyle
/* scopeId */
var Contact___vue_scopeId__ = "data-v-35f7f29f"
/* moduleIdentifier (server only) */
var Contact___vue_module_identifier__ = null
var Contact_Component = Contact_normalizeComponent(
  Contact,
  pages_Contact,
  Contact___vue_template_functional__,
  Contact___vue_styles__,
  Contact___vue_scopeId__,
  Contact___vue_module_identifier__
)

/* harmony default export */ var src_pages_Contact = (Contact_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/About.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var About = ({
  name: 'NewVueComponent',
  props: {},
  components: {},
  watch: {},
  data: function data() {
    return {};
  },

  methods: {},
  computed: {},
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1a5736","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
var About_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var About_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page faq"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("- made for fun")]),_vm._v(" "),_c('p',[_vm._v("- that's all folks, see ya")])])])}]
var About_esExports = { render: About_render, staticRenderFns: About_staticRenderFns }
/* harmony default export */ var pages_About = (About_esExports);
// CONCATENATED MODULE: ./src/pages/About.vue
function About_injectStyle (ssrContext) {
  __webpack_require__("LApv")
}
var About_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var About___vue_template_functional__ = false
/* styles */
var About___vue_styles__ = About_injectStyle
/* scopeId */
var About___vue_scopeId__ = "data-v-7c1a5736"
/* moduleIdentifier (server only) */
var About___vue_module_identifier__ = null
var About_Component = About_normalizeComponent(
  About,
  pages_About,
  About___vue_template_functional__,
  About___vue_styles__,
  About___vue_scopeId__,
  About___vue_module_identifier__
)

/* harmony default export */ var src_pages_About = (About_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Login = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: '',
      error: ''
    };
  },


  methods: {
    makeLogin: function makeLogin() {
      var _this = this;

      auth_service_makeLogin({
        email: this.email,
        password: this.password
      }).then(function (response) {
        _this.error = '';
      }).then(function () {
        getCurrent().then(function (user) {
          return _this.$store.commit('SET_USER', user.data);
        }).then(function () {
          return _this.$router.push('profile');
        }).catch(function (error) {
          return console.log(error);
        });
      }).catch(function (error) {
        console.log('error', error);
        _this.error = error.status === 404 ? 'User with same email not found' : error.message;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee35372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"overlay-fade"}},[_c('div',{staticClass:"login page"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_vm._v("Login")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('md-input-container',[_c('label',[_vm._v("E-mail")]),_vm._v(" "),_c('md-input',{attrs:{"type":"text","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('md-input-container',{attrs:{"md-has-password":""}},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password","required":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.makeLogin($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"buttons"},[_c('md-button',{staticClass:"md-raised",on:{"click":_vm.makeLogin}},[_vm._v("login")])],1),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")]):_vm._e()])])])}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var pages_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/pages/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("tlZd")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  pages_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_pages_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/NotFound.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var NotFound = ({
  name: 'NotFound'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc455c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var NotFound_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found page"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h2',[_vm._v("Page not found")]),_vm._v(" "),_c('div',{staticClass:"smile"},[_vm._v("(>_<)")])])}]
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var pages_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/pages/NotFound.vue
function NotFound_injectStyle (ssrContext) {
  __webpack_require__("ZAaD")
}
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = NotFound_injectStyle
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  pages_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var src_pages_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./src/router/routes.js


// profile





// gallery




// tag

// single pages







var routes = [{
  path: '/',
  name: 'index',
  component: src_pages_Home,
  meta: { title: DOMAIN_TITLE + ' | home' }
}, {
  path: '/news',
  name: 'news',
  component: src_pages_News,
  meta: { title: DOMAIN_TITLE + ' | news' }
}, {
  path: '/gallery',
  name: 'gallery',
  component: pages_gallery_Gallery,
  meta: { title: DOMAIN_TITLE + ' | gallery' }
}, {
  path: '/album/:albumId',
  component: pages_album_Album,
  children: [{
    path: '',
    name: 'album-view',
    component: pages_album_PhotoList,
    props: true,
    meta: { title: DOMAIN_TITLE }
  }, {
    path: 'photo/:photoId',
    name: 'photo-view',
    component: pages_album_Photo,
    props: true,
    meta: { title: DOMAIN_TITLE }
  }]
}, {
  path: '/contact',
  name: 'contact',
  component: src_pages_Contact,
  meta: { title: DOMAIN_TITLE + ' | contact' }
}, {
  path: '/profile',
  component: pages_profile_Profile,
  meta: { isAuth: true, title: DOMAIN_TITLE + ' | profile' },
  children: [{
    path: '',
    name: 'profile',
    component: pages_profile_AlbumsList
  }, {
    path: 'albums',
    name: 'profile-albums',
    component: pages_profile_AlbumsList
  }, {
    path: 'albums/new',
    name: 'profile-albums-new',
    component: pages_profile_AlbumCreateEdit
  }, {
    path: 'albums/:id/edit',
    name: 'profile-album-edit',
    component: pages_profile_AlbumCreateEdit
  }, {
    path: 'tags',
    name: 'profile-tags',
    component: pages_profile_TagsList
  }, {
    path: 'settings',
    name: 'profile-settings',
    component: pages_profile_Settings
  }]
}, {
  path: '/tags/:name',
  name: 'tag',
  component: src_pages_Tag,
  meta: { title: DOMAIN_TITLE }
}, {
  path: '/about',
  name: 'about',
  component: src_pages_About,
  meta: { title: DOMAIN_TITLE + ' | about' }
}, {
  path: '/login',
  name: 'login',
  component: src_pages_Login,
  meta: { title: DOMAIN_TITLE + ' | login' }
}, {
  path: '*',
  component: src_pages_NotFound,
  meta: { title: DOMAIN_TITLE + ' | not found' }
}];
// CONCATENATED MODULE: ./src/router/index.js








vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes: routes
});

/**
 * Initialize app state and check access
 */
function initAppStateMiddleware(to, from, next) {
  // app initialization for auth required routes
  if (to.matched.some(function (item) {
    return item.meta.isAuth;
  })) {
    if (getRefreshToken() && !store.state.userData.id) {
      return refreshTokens().then(function () {
        return getCurrent();
      }).then(function (user) {
        return store.commit('SET_USER', user.data);
      }).then(function () {
        return next();
      }).catch(function (error) {
        return console.log(error);
      });
    }
    if (store.state.userData.id) {
      return next();
    }
    return next({ name: 'login' });
  }

  // app initialization for public routes
  if (getRefreshToken() && !store.state.userData.id) {
    return refreshTokens().then(function () {
      return getCurrent();
    }).then(function (user) {
      return store.commit('SET_USER', user.data);
    }).then(function () {
      return next();
    }).catch(function (error) {
      return console.log(error);
    });
  }

  next();
}

/**
 * Set <title></title> to each page
 */
function setPageTitleMiddleware(to, from, next) {
  var pageTitle = to.matched.find(function (item) {
    return item.meta.title;
  });
  if (pageTitle) {
    window.document.title = pageTitle.meta.title;
  }

  next();
}

router.beforeEach(setPageTitleMiddleware);
router.beforeEach(initAppStateMiddleware);

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/services/auth.service.js









/**
 ******************************
 * @API
 ******************************
 */

function auth_service_makeLogin(_ref) {
  var email = _ref.email,
      password = _ref.password;

  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(API_URL + '/auth/signin', { email: email, password: password }).then(function (response) {
      _setAuthData(response);
      return resolve(new util_ResponseWrapper(response, response.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function makeLogout() {
  return new promise_default.a(function (resolve, reject) {
    new http_init_Http({ auth: true }).post('auth/signout').then(function (response) {
      _resetAuthData();
      src_router.push({ name: 'index' });
      return resolve(new util_ResponseWrapper(response, response.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function refreshTokens() {
  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(API_URL + '/auth/refresh-tokens', { refreshToken: getRefreshToken() }).then(function (response) {
      _setAuthData(response);
      return resolve(new util_ResponseWrapper(response, response.data));
    }).catch(function (error) {
      if (error.response.data.badRefreshToken) {
        console.log('http.init.js >> badRefreshToken: true');
        _resetAuthData();
        src_router.push({ name: 'index' });
        return reject(new util_ErrorWrapper(error));
      }
      if (error.response.data.refreshTokenExpiredError) {
        console.log('http.init.js >> refreshTokenExpiredError');
        _resetAuthData();
        src_router.push({ name: 'index' });
        return reject(new util_ErrorWrapper(error));
      }
    });
  });
}

/**
 ******************************
 * @methods
 ******************************
 */

function isAccessTokenExpired() {
  var accessTokenExpDate = store.state.accessTokenExpDate - 1;
  var nowTime = Math.floor(new Date().getTime() / 1000);

  return accessTokenExpDate <= nowTime;
}

function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

function _resetAuthData() {
  // reset userData in store
  store.commit('SET_USER', {});
  store.commit('SET_ATOKEN_EXP_DATE', null);
  // reset tokens in localStorage
  localStorage.setItem('refreshToken', '');
  localStorage.setItem('accessToken', '');
}

function _setAuthData(response) {
  localStorage.setItem('refreshToken', response.data.refreshToken);
  localStorage.setItem('accessToken', response.data.accessToken);
  store.commit('SET_ATOKEN_EXP_DATE', response.data.expires_in);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Header = ({
  name: 'Header',
  data: function data() {
    return {
      isVisibleMobMenu: false
    };
  },


  methods: {
    logout: function logout() {
      makeLogout();
    },
    toggleMobMenu: function toggleMobMenu() {
      this.isVisibleMobMenu = !this.isVisibleMobMenu;
    },
    handleMobMenuClick: function handleMobMenuClick($event) {
      if ($event.target.tagName === 'A') {
        this.toggleMobMenu();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f736016","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header wrapper"},[_c('div',{staticClass:"menu-wrapper"},[(_vm.$store.getters.isTablet)?_c('div',{staticClass:"hamburger",on:{"click":_vm.toggleMobMenu}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])]):_vm._e(),_vm._v(" "),(!_vm.$store.getters.isTablet)?_c('ul',{staticClass:"menu"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'index' },"exact":""}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'news' }}},[_vm._v("News")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'gallery' }}},[_vm._v("Gallery")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("Contact")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"small",attrs:{"to":{ name: 'about' }}},[_vm._v("about")])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.$currentUser.id)?_c('li',[_c('router-link',{staticClass:"small",attrs:{"to":{ name: 'profile' }}},[_vm._v("\n        Profile\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.$currentUser.id)?_c('li',[_c('button',{staticClass:"logout small",on:{"click":_vm.logout}},[_vm._v("\n          Logout\n        ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.getters.isTablet && _vm.isVisibleMobMenu)?_c('ul',{staticClass:"menu is-mobile",on:{"click":_vm.handleMobMenuClick}},[(_vm.isVisibleMobMenu)?_c('li',{on:{"click":_vm.toggleMobMenu}},[_c('i',{staticClass:"material-icons close-mob-menu"},[_vm._v("close")])]):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'index' },"exact":""}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'news' }}},[_vm._v("News")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'gallery' }}},[_vm._v("Gallery")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("Contact")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"small",attrs:{"to":{ name: 'about' }}},[_vm._v("about")])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"small",attrs:{"href":"http://whiteside.in.ua/","target":"_blank"}},[_vm._v("archive")])]),_vm._v(" "),(_vm.isVisibleMobMenu)?_c('li',{on:{"click":_vm.toggleMobMenu}},[_c('i',{staticClass:"material-icons close-mob-menu"},[_vm._v("close")])]):_vm._e()]):_vm._e()])],1)])}
var Header_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"small",attrs:{"href":"http://whiteside.in.ua/","target":"_blank"}},[_vm._v("archive")])])}]
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var components_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("4zqS")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = "data-v-8f736016"
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  components_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Footer = ({
  name: 'Footer',
  computed: {
    years: function years() {
      return new Date().getFullYear() === 2018 ? 2018 : '2018 - ' + new Date().getFullYear();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99324fb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"BOLD"},[_vm._v("whitesidetimes.com © "+_vm._s(_vm.years)+" | "),_c('a',{attrs:{"href":"https://github.com/zmts","target":"_blank"}},[_vm._v("DESIGNED BY ZMTS")])])])}
var Footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BOLD"},[_c('a',{attrs:{"href":"https://www.facebook.com/whitesidetimes","target":"_blank"}},[_vm._v("fb")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/whitesidetimes/","target":"_blank"}},[_vm._v("ins")]),_vm._v(" "),_c('a',{attrs:{"href":"https://vimeo.com/whiteside","target":"_blank"}},[_vm._v("vimeo")])])}]
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var components_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/components/Footer.vue
function Footer_injectStyle (ssrContext) {
  __webpack_require__("QO6j")
}
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = Footer_injectStyle
/* scopeId */
var Footer___vue_scopeId__ = "data-v-99324fb4"
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  components_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_components_Footer = (Footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app.layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var app_layout = ({
  name: 'AppLayout',
  components: {
    AppHeader: src_components_Header,
    AppFooter: src_components_Footer
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6213d340","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.layout.vue
var app_layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-snotify'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var app_layout_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("7Otq"),"alt":"Whiteside times logo"}})])}]
var app_layout_esExports = { render: app_layout_render, staticRenderFns: app_layout_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_app_layout = (app_layout_esExports);
// CONCATENATED MODULE: ./src/app.layout.vue
function app_layout_injectStyle (ssrContext) {
  __webpack_require__("IIHs")
}
var app_layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var app_layout___vue_template_functional__ = false
/* styles */
var app_layout___vue_styles__ = app_layout_injectStyle
/* scopeId */
var app_layout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var app_layout___vue_module_identifier__ = null
var app_layout_Component = app_layout_normalizeComponent(
  app_layout,
  selectortype_template_index_0_src_app_layout,
  app_layout___vue_template_functional__,
  app_layout___vue_styles__,
  app_layout___vue_scopeId__,
  app_layout___vue_module_identifier__
)

/* harmony default export */ var src_app_layout = (app_layout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataBox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DataBox = ({
  name: 'DataBox',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Boolean],
      default: false
    }
  },
  components: { SpinnerWave: src_components_SpinnerWave }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4cb3a42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataBox.vue
var DataBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-box component"},[(_vm.loading)?_c('div',{staticClass:"data-box-content",class:{'loading': _vm.loading}},[_c('SpinnerWave')],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEmpty && !_vm.error && !_vm.loading),expression:"!isEmpty && !error && !loading"}],staticClass:"data-box-content",class:{'loading': _vm.loading}},[_vm._t("default")],2),_vm._v(" "),(_vm.isEmpty && !_vm.error && !_vm.loading)?_c('div',{staticClass:"data-box-content is-empty"},[_c('div',{staticClass:"smile"},[_vm._v("(>_<)")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("No content!")])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"data-box-content error"},[_c('div',{staticClass:"smile"},[_vm._v("(>_<)")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Something wrong here!")]),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var DataBox_staticRenderFns = []
var DataBox_esExports = { render: DataBox_render, staticRenderFns: DataBox_staticRenderFns }
/* harmony default export */ var components_DataBox = (DataBox_esExports);
// CONCATENATED MODULE: ./src/components/DataBox.vue
function DataBox_injectStyle (ssrContext) {
  __webpack_require__("qKd0")
}
var DataBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataBox___vue_template_functional__ = false
/* styles */
var DataBox___vue_styles__ = DataBox_injectStyle
/* scopeId */
var DataBox___vue_scopeId__ = "data-v-b4cb3a42"
/* moduleIdentifier (server only) */
var DataBox___vue_module_identifier__ = null
var DataBox_Component = DataBox_normalizeComponent(
  DataBox,
  components_DataBox,
  DataBox___vue_template_functional__,
  DataBox___vue_styles__,
  DataBox___vue_scopeId__,
  DataBox___vue_module_identifier__
)

/* harmony default export */ var src_components_DataBox = (DataBox_Component.exports);

// CONCATENATED MODULE: ./src/mixins/currentUser.js
/* harmony default export */ var currentUser = ({
  computed: {
    $currentUser: function $currentUser() {
      if (!this.$store) return;
      return {
        id: this.$store.state.userData.id,
        name: this.$store.state.userData.name,
        role: this.$store.state.userData.role,
        email: this.$store.state.userData.email
      };
    }
  }
});
// CONCATENATED MODULE: ./src/config/datetime.js
/* harmony default export */ var datetime = ({
  FORMAT_DATE: 'MM/DD/YYYY',
  FORMAT_TIME: 'hh:mm:ss',
  FORMAT_DATETIME: 'MM/DD/YYYY hh:mm:ss'
});
// CONCATENATED MODULE: ./src/config/index.js



// CONCATENATED MODULE: ./src/mixins/formatDateTime.js


/* harmony default export */ var formatDateTime = ({
  computed: {
    $FORMAT_DATETIME: function $FORMAT_DATETIME() {
      return {
        DATE: datetime.FORMAT_DATE,
        TIME: datetime.FORMAT_TIME,
        DATETIME: datetime.FORMAT_DATETIME
      };
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vue-material/dist/vue-material.css
var dist_vue_material = __webpack_require__("tzNG");
var dist_vue_material_default = /*#__PURE__*/__webpack_require__.n(dist_vue_material);

// EXTERNAL MODULE: ./node_modules/vue-snotify/styles/simple.scss
var simple = __webpack_require__("0Z0D");
var simple_default = /*#__PURE__*/__webpack_require__.n(simple);

// EXTERNAL MODULE: ./node_modules/vue-datetime/dist/vue-datetime.css
var dist_vue_datetime = __webpack_require__("suTU");
var dist_vue_datetime_default = /*#__PURE__*/__webpack_require__.n(dist_vue_datetime);

// EXTERNAL MODULE: ./src/assets/fonts/bebasneue.css
var bebasneue = __webpack_require__("Rtn+");
var bebasneue_default = /*#__PURE__*/__webpack_require__.n(bebasneue);

// EXTERNAL MODULE: ./src/scss/style.scss
var style = __webpack_require__("xnyV");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/app.init.js
// global imports

// import global components






// app imports



// import local components

// mixins imports


// styles imports






// use global components
vue_esm["default"].use(dist_default.a);
vue_esm["default"].use(vue_moment_default.a);
vue_esm["default"].use(v_tooltip_esm["a" /* default */]);
vue_esm["default"].use(vue_material_default.a);
vue_esm["default"].use(vue_snotify_esm["a" /* default */], {
  toast: {
    timeout: 10 * 1000,
    position: 'leftTop',
    showProgressBar: false
  }
});
vue_esm["default"].use(vuejs_dialog_min_default.a, {
  animation: 'fade',
  okText: 'ок',
  cancelText: 'сancel'
});
// use local components
vue_esm["default"].component('UiDataBox', src_components_DataBox);
// use mixins
vue_esm["default"].mixin(currentUser);
vue_esm["default"].mixin(formatDateTime);

vue_esm["default"].config.productionTip = false;
/* eslint-disable no-new */
new vue_esm["default"]({
  name: 'Root',
  template: '<AppLayout/>',
  components: { AppLayout: src_app_layout },
  el: '#app',
  router: src_router,
  store: store,

  mounted: function mounted() {
    store.commit('SET_WINDOW_WIDTH', window.innerWidth);
    window.addEventListener('resize', function () {
      return store.commit('SET_WINDOW_WIDTH', window.innerWidth);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', function () {
      return store.commit('SET_WINDOW_WIDTH', window.innerWidth);
    });
  }
});

/***/ }),

/***/ "0Z0D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4zqS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.97aa8b8.png";

/***/ }),

/***/ "CvRq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IIHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ITo8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LApv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LnKE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mmdl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P/8s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QO6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rtn+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYG6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wrda":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YrBY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZAaD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a6mb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bFOC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gYkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k+3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kfjf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lboT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mCkW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mP6D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nQWg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oDzh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qDU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qKd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sKjR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "suTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tcXH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlZd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "w8db":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wGQz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVqI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xnyV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z/bq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["0Flw"]);


// WEBPACK FOOTER //
// static/js/app.5080181052110a6a6f6f.js